<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="(billOfLadingQr) ? setStatus : submit"
    :secondary-submit="undoStatus"
    :submit-btn-text="(billOfLadingQr) ? setStatusButtonText() : submitBtnText()"
    :secondary-btn-text="undoStatusButtonText()"
    :is-submit-btn="(billOfLadingQr) ? isSetStatusButtonVisible() : isSubmitBtn()"
    :is-secondary-btn="(billOfLadingQr) ? isUndoStatusButtonVisible() : false"
    :full-screen="true"
    :persistent="true"
  >
    <template slot="header">
      <span>{{ headlineText() }}</span>
    </template>
    <template slot="body">
      <!-- Bill Of Lading QR -->
      <v-row v-if="billOfLadingQr">
        <v-col
          v-if="item && item.status"
          class="text-center"
        >
          <h3 class="h3">
            Status
          </h3>
          <v-chip
            medium
            :color="item && item.status ? item.status.color : 'black'"
            text-color="white"
            class="mt-1"
          >
            {{ item && item.status ? item.status.name : '' }}
          </v-chip>
        </v-col>
        <v-col
          v-if="item"
          class="text-center"
        >
          <h3 class="h3">
            Job Ref
          </h3>
          <span class="mt-1 font-weight-bold">{{ item.job_code ? `${item.job_code}` : '' }}</span> - {{ item.job_name ? item.job_name : item.job_name }} <span style="color: #1976D2;">{{ item.job_reference ? `; ${item.job_reference}` : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.truck && item.truck.type"
          class="text-center"
        >
          <h3 class="h3">
            Truck Type
          </h3>
          <v-chip
            medium
            :color="item && item.truck && item.truck.type ? item.truck.type.color : 'black'"
            text-color="white"
            class="mt-1"
          >
            {{ item && item.truck && item.truck.type ? item.truck.type.name : '' }}
          </v-chip>
        </v-col>
        <v-col
          v-if="item && item.truck"
          class="text-center"
        >
          <h3 class="h3">
            Truck Number
          </h3>
          <span class="mt-1 font-weight-bold">{{ item && item.truck ? item.truck.truck_number : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.truck"
          class="text-center"
        >
          <h3 class="h3">
            Plate Number
          </h3>
          <span class="mt-1 font-weight-bold">{{ item && item.truck ? item.truck.plate_number : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.shipped_at"
          class="text-center"
        >
          <h3 class="h3">
            Shipped Date
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? formatDateTime(item.shipped_at) : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.shipped_by_full_name"
          class="text-center"
        >
          <h3 class="h3">
            Shipped By
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.shipped_by_full_name : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.received_at"
          class="text-center"
        >
          <h3 class="h3">
            Received Date
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? formatDateTime(item.received_at) : '' }}</span>
        </v-col>
        <v-col
          v-if="item && item.received_by_full_name"
          class="text-center"
        >
          <h3 class="h3">
            Received By
          </h3>
          <span class="mt-1 font-weight-bold">{{ item ? item.received_by_full_name : '' }}</span>
        </v-col>
        <v-col
          class="text-center"
        >
          <h3 class="h3">
            Total Weight
          </h3>
          <span class="mt-1 font-weight-bold">{{ getAllTotalWeightKilograms().toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}kg</span>
        </v-col>
      </v-row>
      <!-- Bill Of Lading -->
      <v-row v-if="!billOfLadingQr">
        <v-col
          cols="3"
          class="text-start pr-0"
        >
          <v-text-field
            v-model="tagQr"
            autofocus
            :disabled="isOpen"
            @keydown.enter.native.prevent
            @input="qrCodeValueChange"
          />
        </v-col>
        <v-col
          cols="auto"
          class="mt-4 pb-0"
        >
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div v-on="!tagQr ? on : ''">
                <v-btn
                  v-bind="attrs"
                  color="primary"
                  outlined
                  :disabled="!tagQr || isOpen"
                  @click="handleTagAction"
                  @keyup.enter="handleTagAction"
                >
                  {{ `${returnItem ? 'Return FG Tag' : 'Scan'}` }}
                </v-btn>
              </div>
            </template>
            <span> {{ `${returnItem ? 'Return Finished Good Tag' : 'Add Finished Good Tag'}` }} </span>
          </v-tooltip>
        </v-col>
        <v-spacer />
        <v-col
          class="mt-4 pb-0"
          cols="auto"
        >
          <span
            style="font-size: 60px; font-weight: bold;"
            :style="{color: getTotalWeightColor()}"
          >Total Weight: {{ getAllTotalWeightKilograms().toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}kg ({{ getAllTotalWeightPounds().toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}lb)</span>
        </v-col>
        <v-col
          class="mt-4 pb0-"
          cols="auto"
        >
          <span
            style="font-size: 60px; font-weight: bold;"
            :style="{color: getTotalWeightColor()}"
          >Total Quantity: {{ getTotalQuantity() }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card
            elevation="0"
            outlined
          >
            <!-- Datatable for DOORS -->
            <v-data-table
              v-if="isDoorMode()"
              :headers="headers"
              :items="doorTableItems"
              hide-default-footer
              :items-per-page="-1"
              fixed-header
              :height="tableHeight"
              show-expand
              :expanded.sync="expandedDoorItems"
              dense
              :item-class="itemRowBackground"
            >
              <template #[`item.data-table-expand`]="{ item }">
                <tr>
                  <td>
                    <v-icon
                      v-if="
                        item.frames &&
                          item.frames.length > 0
                      "
                      style="font-size: 22px !important"
                      @click="toggleExpand(item)"
                    >
                      {{
                        expandedDoorItems.includes(item)
                          ? 'mdi-chevron-down'
                          : 'mdi-chevron-up'
                      }}
                    </v-icon>
                  </td>
                </tr>
              </template>
              <template
                v-for="h in headers"
                #[`header.${h.value}`]="{ header }"
              >
                <v-tooltip
                  v-if="h.fullText"
                  :key="h.value"
                  top
                >
                  <template #activator="{ on }">
                    <span v-on="on">{{ header.text }}</span>
                  </template>
                  <span>{{ header.fullText }}</span>
                </v-tooltip>
                <span
                  v-else
                  :key="h.value"
                >
                  {{ h.text }}
                </span>
              </template>
              <template #[`item.finished_good.tag_id`]="{ item }">
                <span style="font-weight: bold">
                  {{ item && item.finished_good && item.finished_good.tag_id ? item.finished_good.tag_id : '-' }}
                </span>
              </template>
              <template #[`item.sequence_number`]="{ item }">
                {{ item && item.finished_good && item.finished_good.tag_id ? extractSequenceNumber(item.finished_good) : '-' }}
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip
                  v-if="item && item.status"
                  small
                  :color="item.status.color ? item.status.color : '#000000'"
                  text-color="white"
                >
                  {{ item.status.name }}
                </v-chip>
              </template>
              <template #[`item.total_components`]="{ item }">
                {{ item && item.frames ? item.frames.length : '-' }}
              </template>
              <template #[`item.finished_good.type`]="{ item }">
                {{ item && item.finished_good && item.finished_good.type ? item.finished_good.type.name : '-' }}
              </template>
              <template #[`item.finished_good.sqft`]="{ item }">
                {{ item && item.finished_good && item.finished_good.sqft ? `${item.finished_good.sqft.toFixed(2)} sqft` : '-' }}
              </template>
              <template #[`item.finished_good.width`]="{ item }">
                {{ item && item.finished_good && item.finished_good.type_id !== finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== finishedGoodCommercialTypeIdSlab && item.finished_good.width ? `${displayInchesWithFraction(item.finished_good.width)}` : '-' }}
              </template>
              <template #[`item.finished_good.height`]="{ item }">
                {{ item && item.finished_good && item.finished_good.type_id !== finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== finishedGoodCommercialTypeIdSlab && item.finished_good.height ? `${displayInchesWithFraction(item.finished_good.height)}` : '-' }}
              </template>
              <template #[`item.finished_good.length`]="{ item }">
                {{ item && item.finished_good && (item.finished_good.type_id == finishedGoodCommercialTypeIdFrame || item.finished_good.type_id == finishedGoodCommercialTypeIdSlab) &&
                    getLengthFromFinishedGoodComponent(item.finished_good) ? `${displayInchesWithFraction(getLengthFromFinishedGoodComponent(item.finished_good))}`: '-' }}
              </template>
              <template #[`item.finished_good.weight`]="{ item }">
                <span
                  v-if="
                    getFinishedGoodWeightKilograms(item.finished_good)
                  "
                  style="font-weight: bold"
                >
                  {{ getFinishedGoodWeight(item.finished_good) }}
                </span>
                <span v-else>
                  <v-tooltip left>
                    <template #activator="{ on }">
                      <span
                        style="color: red; font-weight: bold;"
                        v-on="on"
                      >!</span>
                    </template>
                    <span> Missing {{ getFinishedGoodMissingField(item.finished_good) }}; Unable to calculate weight </span>
                  </v-tooltip>
                </span>
              </template>
              <template #expanded-item="{ headers, item }">
                <td
                  class="px-2 py-2"
                  :colspan="headers.length"
                >
                  <div class="commercial-bol-expand-animate">
                    <v-data-table
                      v-if="
                        item.frames &&
                          item.frames.length > 0 &&
                          item.frames
                      "
                      id="sub-table"
                      class="commercial-bol-subtable level-1"
                      :colspan="headers.length"
                      :headers="doorComponentHeaders"
                      :items="item.frames"
                      hide-default-footer
                      :items-per-page="-1"
                      dense
                      :item-class="itemRowBackground"
                    >
                      <template #[`item.finished_good.tag_id`]="{ item }">
                        <span style="font-weight: bold">
                          {{ item && item.finished_good && item.finished_good.tag_id ? item.finished_good.tag_id : '-' }}
                        </span>
                      </template>
                      <template #[`item.sequence_number`]="{ item }">
                        {{ item && item.finished_good && item.finished_good.tag_id ? extractSequenceNumber(item.finished_good) : '-' }}
                      </template>
                      <template #[`item.status`]="{ item }">
                        <v-chip
                          v-if="item && item.status"
                          small
                          :color="item.status.color ? item.status.color : '#000000'"
                          text-color="white"
                        >
                          {{ item.status.name }}
                        </v-chip>
                      </template>
                      <template #[`item.finished_good.type`]="{ item }">
                        <span>
                          {{ item && item.finished_good && item.finished_good.type ? item.finished_good.type.name : '-' }}
                        </span>
                      </template>
                      <template #[`item.finished_good.aluminum_die.code`]="{ item }">
                        {{ getFinishedGoodAluminumDieCode(item.finished_good) }}
                      </template>

                      <template #[`item.finished_good.int_color.code`]="{ item }">
                        {{ getFinishedGoodIntColorCode(item.finished_good) }}
                      </template>

                      <template #[`item.finished_good.ext_color.code`]="{ item }">
                        {{ getFinishedGoodExtColorCode(item.finished_good) }}
                      </template>
                      <template #[`item.finished_good.length`]="{ item }">
                        {{ item && item.finished_good && (item.finished_good.type_id == finishedGoodCommercialTypeIdFrame || item.finished_good.type_id == finishedGoodCommercialTypeIdSlab) &&
                            getLengthFromFinishedGoodComponent(item.finished_good) ? `${displayInchesWithFraction(getLengthFromFinishedGoodComponent(item.finished_good))}`: '-' }}
                      </template>
                      <template #[`item.finished_good.weight`]="{ item }">
                        <span
                          v-if="
                            getFinishedGoodWeightKilograms(item.finished_good)
                          "
                          style="font-weight: bold"
                        >
                          {{ getFinishedGoodWeight(item.finished_good) }}
                        </span>
                        <span v-else>
                          <v-tooltip left>
                            <template #activator="{ on }">
                              <span
                                style="color: red; font-weight: bold;"
                                v-on="on"
                              >!</span>
                            </template>
                            <span> Missing {{ getFinishedGoodMissingField(item.finished_good) }}; Unable to calculate weight </span>
                          </v-tooltip>
                        </span>
                      </template>
                      <template #[`item.actions`]="{ item }">
                        <v-btn
                          v-if="!returnItem && !isOpen"
                          class="ml-1 mt-1 mb-1"
                          color="error"
                          outlined
                          small
                          @click="removeTag(item)"
                        >
                          REMOVE
                        </v-btn>
                        <v-btn
                          v-if="returnItem"
                          class="ml-1 mt-1 mb-1"
                          color="error"
                          outlined
                          small
                          @click="toggleReturnTag(item)"
                        >
                          {{ item.is_return || (item.status_id === finishedGoodStatusIdReturned) ? 'UNDO RETURN' : 'RETURN' }}
                        </v-btn>
                      </template>
                    </v-data-table>
                  </div>
                </td>
              </template>
              <template slot="body.append">
                <tr>
                  <th />
                  <th />
                  <th />
                  <th />
                  <th v-if="item && item.job && item.job.sub_class_id === jobSubClassIdCommDoors"/>
                  <th v-if="item && item.job && item.job.sub_class_id === jobSubClassIdCommDoors"/>
                  <th />
                  <th class="text-end pr-1">
                    <span style="color: #000000; font-weight: bold; font-size: 14px;">Totals: </span>
                  </th>
                  <th class="text-end">
                    <span style="font-weight: bold; font-size: 14px;">{{ parseFloat(getTotalSqft()).toLocaleString('en-US', { maximumFractionDigits: 2 }) }} sqft</span>
                  </th>
                  <th class="text-end">
                    <span style="font-weight: bold; font-size: 14px;">{{ displayInchesWithFraction(getTotalWidth()) }}</span>
                  </th>
                  <th class="text-end">
                    <span style="font-weight: bold; font-size: 14px;">{{ displayInchesWithFraction(getTotalHeight()) }}</span>
                  </th>
                  <th class="text-end">
                    <span style="font-weight: bold; font-size: 14px;">{{ (item && item.job && item.job.sub_class_id === jobSubClassIdCommDoors) ? '' : displayInchesWithFraction(getTotalLength()) }}</span>
                  </th>
                  <th class="text-end">
                    <span style="font-weight: bold; font-size: 14px;">{{ parseFloat(getTotalWeightKilograms()).toLocaleString('en-US', { maximumFractionDigits: 0 }) }}</span>
                  </th>
                  <th />
                  <th />
                </tr>
              </template>
            </v-data-table>

            <!-- Datatable for WINDOWS -->
            <v-data-table
              v-else
              :headers="windowHeaders"
              :items="windowTableItems"
              hide-default-footer
              :items-per-page="-1"
              fixed-header
              :height="tableHeight"
              show-expand
              :expanded.sync="expandedWindowItems"
              item-key="temp_id"
              dense
              :item-class="getTopLevelRowClass"
            >
              <template #[`item.data-table-expand`]="{ item }">
                <tr>
                  <td>
                    <v-icon
                      v-if="isWindowRowExpandable(item)"
                      style="font-size: 22px !important"
                      @click="toggleExpand(item)"
                    >
                      {{
                        expandedWindowItems.includes(item)
                          ? 'mdi-chevron-down'
                          : 'mdi-chevron-up'
                      }}
                    </v-icon>
                  </td>
                </tr>
              </template>

              <template #[`item.type`]="{ item }">
                {{ getWindowRowType(item) }}
              </template>

              <template #[`item.number_or_tag`]="{ item }">
                {{ getWindowRowNumberOrTag(item) }}
              </template>

              <template #[`item.quantity`]="{ item }">
                {{ getWindowRowQuantity(item) }}
              </template>

              <template #[`item.weight`]="{ item }">
                {{ getWindowRowWeight(item) }}
              </template>

              <template #[`item.actions`]="{ item }">
                <v-btn
                  v-if="!returnItem && !isOpen && shouldShowTopLevelRemoveButton(item)"
                  class="ml-1 mt-1 mb-1"
                  color="error"
                  outlined
                  small
                  @click="removeTag(item)"
                >
                  REMOVE
                </v-btn>
              </template>

              <template #expanded-item="{ headers, item }">
                <td
                  class="px-2 py-2"
                  :colspan="headers.length"
                >
                  <div class="commercial-bol-expand-animate">
                    <!-- Direct FG or Bundle -->
                    <v-data-table
                      v-if="item.is_finished_good_group || item.finished_good || item.commercial_bundle"
                      id="sub-table"
                      class="commercial-bol-subtable level-1"
                      :headers="windowFinishedGoodAndBundleSubHeaders"
                      :items="getWindowRowChildren(item)"
                      hide-default-footer
                      :items-per-page="-1"
                      dense
                      :class="getSubTableClass(item)"
                      :item-class="getFinishedGoodRowClass"
                    >
                      <template
                        v-for="h in windowFinishedGoodAndBundleSubHeaders"
                        #[`header.${h.value}`]="{ header }"
                      >
                        <v-tooltip
                          v-if="h.fullText"
                          :key="h.value"
                          top
                        >
                          <template #activator="{ on }">
                            <span v-on="on">{{ header.text }}</span>
                          </template>
                          <span>{{ header.fullText }}</span>
                        </v-tooltip>
                        <span
                          v-else
                          :key="h.value"
                        >
                          {{ h.text }}
                        </span>
                      </template>

                      <template #[`item.finished_good.tag_id`]="{ item }">
                        <span style="font-weight: bold">
                          {{ getFinishedGoodTagId(item) }}
                        </span>
                      </template>

                      <template #[`item.finished_good.tag_number`]="{ item }">
                        <span style="font-weight: bold">
                          {{ getFinishedGoodTagNumber(item) }}
                        </span>
                      </template>

                      <template #[`item.finished_good.sequence_number`]="{ item }">
                        {{ getFinishedGoodSequenceNumber(item) }}
                      </template>

                      <template #[`item.finished_good.aluminum_die.code`]="{ item }">
                        {{ getFinishedGoodAluminumDieCode(item) }}
                      </template>

                      <template #[`item.finished_good.int_color.code`]="{ item }">
                        {{ getFinishedGoodIntColorCode(item) }}
                      </template>

                      <template #[`item.finished_good.ext_color.code`]="{ item }">
                        {{ getFinishedGoodExtColorCode(item) }}
                      </template>

                      <template #[`item.finished_good.type`]="{ item }">
                        {{ getFinishedGoodType(item) }}
                      </template>

                      <template #[`item.status`]="{ item }">
                        <v-chip
                          v-if="hasFinishedGoodStatus(item)"
                          small
                          :color="getFinishedGoodStatusColor(item)"
                          text-color="white"
                        >
                          {{ getFinishedGoodStatusName(item) }}
                        </v-chip>
                      </template>

                      <template #[`item.finished_good.sqft`]="{ item }">
                        {{ getFinishedGoodSqft(item) }}
                      </template>

                      <template #[`item.finished_good.width`]="{ item }">
                        {{ getFinishedGoodWidth(item) }}
                      </template>

                      <template #[`item.finished_good.height`]="{ item }">
                        {{ getFinishedGoodHeight(item) }}
                      </template>

                      <template #[`item.finished_good.length`]="{ item }">
                        {{ getFinishedGoodLength(item) }}
                      </template>

                      <template #[`item.finished_good.weight`]="{ item }">
                        <span
                          v-if="
                            getFinishedGoodWeightKilograms(item)
                          "
                          style="font-weight: bold"
                        >
                          {{ getFinishedGoodWeight(item) }}
                        </span>
                        <span v-else>
                          <v-tooltip left>
                            <template #activator="{ on }">
                              <span
                                :style="{
                                  color: 'red',
                                  fontWeight: 'bold',
                                }"
                                v-on="on"
                              >
                                !
                              </span>
                            </template>
                            <span>Missing {{ getFinishedGoodMissingField(item) }}; Unable to calculate weight</span>
                          </v-tooltip>
                        </span>
                      </template>

                      <template #[`item.actions`]="{ item: finishedGood }">
                        <v-btn
                          v-if="
                            !returnItem &&
                            !isOpen &&
                            item &&
                            item.is_finished_good_group &&
                            item.finished_goods &&
                            item.finished_goods.length > 1
                          "
                          class="ml-1 mt-1 mb-1"
                          color="error"
                          outlined
                          small
                          @click="removeTag({ finished_good: finishedGood })"
                        >
                          REMOVE
                        </v-btn>
                      </template>
                    </v-data-table>

                    <!-- Skid -->
                    <v-data-table
                      v-else-if="item.commercial_skid"
                      id="sub-table"
                      class="commercial-bol-subtable level-1"
                      :headers="windowSkidChildHeaders"
                      :items="getWindowRowChildren(item)"
                      hide-default-footer
                      :items-per-page="-1"
                      dense
                      show-expand
                      :expanded.sync="expandedSkidChildItems"
                      item-key="temp_id"
                      :class="getSubTableClass(item)"
                      :item-class="getWindowSkidChildRowClass"
                    >
                      <template #[`item.data-table-expand`]="{ item }">
                        <tr>
                          <td>
                            <v-icon
                              v-if="isWindowSkidChildRowExpandable(item)"
                              style="font-size: 22px !important"
                              @click="toggleSkidChildExpand(item)"
                            >
                              {{
                                expandedSkidChildItems.includes(item)
                                  ? 'mdi-chevron-down'
                                  : 'mdi-chevron-up'
                              }}
                            </v-icon>
                          </td>
                        </tr>
                      </template>

                      <template #[`item.type`]="{ item }">
                        {{ getWindowSkidChildRowType(item) }}
                      </template>

                      <template #[`item.number_or_tag`]="{ item }">
                        {{ getWindowSkidChildRowNumberOrTag(item) }}
                      </template>

                      <template #[`item.quantity`]="{ item }">
                        {{ getWindowSkidChildRowQuantity(item) }}
                      </template>

                      <template #[`item.weight`]="{ item }">
                        {{ getWindowRowWeight(item) }}
                      </template>

                      <template #expanded-item="{ headers, item }">
                        <td
                          class="px-2 py-2"
                          :colspan="headers.length"
                        >
                          <div class="commercial-bol-expand-animate">
                            <!-- SKID CHILD ROWS (FINISHED GOODS OR BUNDLES) -->
                            <v-data-table
                              id="sub-table"
                              class="commercial-bol-subtable level-2"
                              :class="getSubTableClass(item)"
                              :headers="windowFinishedGoodAndBundleSubHeaders"
                              :items="getWindowSkidChildRowChildren(item)"
                              hide-default-footer
                              :items-per-page="-1"
                              dense
                              :header-class="getSubTableHeaderClass(item)"
                              :item-class="getFinishedGoodRowClass"
                            >
                              <template
                                v-for="h in windowFinishedGoodAndBundleSubHeaders"
                                #[`header.${h.value}`]="{ header }"
                              >
                                <v-tooltip
                                  v-if="h.fullText"
                                  :key="h.value"
                                  top
                                >
                                  <template #activator="{ on }">
                                    <span v-on="on">{{ header.text }}</span>
                                  </template>
                                  <span>{{ header.fullText }}</span>
                                </v-tooltip>
                                <span
                                  v-else
                                  :key="h.value"
                                >
                                  {{ h.text }}
                                </span>
                              </template>

                              <template #[`item.finished_good.tag_id`]="{ item }">
                                <span style="font-weight: bold">
                                  {{ getFinishedGoodTagId(item) }}
                                </span>
                              </template>

                              <template #[`item.finished_good.tag_number`]="{ item }">
                                <span style="font-weight: bold">
                                  {{ getFinishedGoodTagNumber(item) }}
                                </span>
                              </template>

                              <template #[`item.finished_good.sequence_number`]="{ item }">
                                {{ getFinishedGoodSequenceNumber(item) }}
                              </template>

                              <template #[`item.finished_good.type`]="{ item }">
                                {{ getFinishedGoodType(item) }}
                              </template>

                              <template #[`item.finished_good.aluminum_die.code`]="{ item }">
                                {{ getFinishedGoodAluminumDieCode(item) }}
                              </template>

                              <template #[`item.finished_good.int_color.code`]="{ item }">
                                {{ getFinishedGoodIntColorCode(item) }}
                              </template>

                              <template #[`item.finished_good.ext_color.code`]="{ item }">
                                {{ getFinishedGoodExtColorCode(item) }}
                              </template>

                              <template #[`item.status`]="{ item }">
                                <v-chip
                                  v-if="hasFinishedGoodStatus(item)"
                                  small
                                  :color="getFinishedGoodStatusColor(item)"
                                  text-color="white"
                                >
                                  {{ getFinishedGoodStatusName(item) }}
                                </v-chip>
                              </template>

                              <template #[`item.finished_good.sqft`]="{ item }">
                                {{ getFinishedGoodSqft(item) }}
                              </template>

                              <template #[`item.finished_good.width`]="{ item }">
                                {{ getFinishedGoodWidth(item) }}
                              </template>

                              <template #[`item.finished_good.height`]="{ item }">
                                {{ getFinishedGoodHeight(item) }}
                              </template>

                              <template #[`item.finished_good.length`]="{ item }">
                                {{ getFinishedGoodLength(item) }}
                              </template>

                              <template #[`item.finished_good.weight`]="{ item }">
                                <span
                                  v-if="
                                    getFinishedGoodWeightKilograms(item)
                                  "
                                  style="font-weight: bold"
                                >
                                  {{ getFinishedGoodWeight(item) }}
                                </span>
                                <span v-else>
                                  <v-tooltip left>
                                    <template #activator="{ on }">
                                      <span
                                        style="color: red; font-weight: bold"
                                        v-on="on"
                                      >
                                        !
                                      </span>
                                    </template>
                                    <span>Missing {{ getFinishedGoodMissingField(item) }}; Unable to calculate weight</span>
                                  </v-tooltip>
                                </span>
                              </template>
                            </v-data-table>
                          </div>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-if="isWindowMode() || !bolMode"
        class="mt-2"
      >
        <v-col
          cols="auto"
          class="pb-0 pt-0"
        >
          <v-btn
            outlined
            color="success"
            class="mt-3"
            @click="openFinishedGoodForm"
          >
            VIEW FINISHED GOODS
          </v-btn>
        </v-col>
        <v-spacer />
        <v-col
          cols="auto"
          class="pb-0 pt-0"
        >
          <v-switch
            v-model="expandAllPanels"
            hide-details
            class="mt-0 pt-3"
            :label="expandAllPanels ? 'Collapse All' : 'Expand All'"
            @change="handleExpandAllChange"
          />
        </v-col>
        <v-col cols="auto">
          <div class="d-flex justify-end mr-4">
            <span class="commercial-bol-summary-text">
              SKIDS: {{ getTotalSkidCount() }},
              BUNDLES: {{ getTotalBundleCount() }},
              FINISHED GOODS: {{ getTotalFinishedGoodCount() }}
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <commercial-bill-of-lading-extra-item-form
            ref="billOfLadingExtraItemForm"
            :return-item="returnItem"
            :bill-of-lading-qr="billOfLadingQr"
            :is-view="isOpen"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="!billOfLadingQr"
        align="center"
        justify="center"
        style="background-color: #f9f9f9"
        class="my-6"
      >
        <!-- <v-col
          cols="2"
          class="mt-4 pb-0"
        >
          <v-autocomplete
            v-model="scheduledDeliveryId"
            :items="scheduledDeliveries"
            item-text="title"
            item-value="id"
            :disabled="returnItem || isOpen"
            clearable
            @change="handleScheduledDeliveryChange"
            :loading="loadingScheduledDeliveries"
          >
            <template slot="label">
              Delivery #
            </template>
          </v-autocomplete>
        </v-col> -->
        <v-col
          cols="2"
          class="mt-4 pb-0"
        >
          <v-select
            v-model="truckTypeId"
            label="Truck Type"
            :items="truckTypes"
            item-text="name"
            item-value="id"
            :disabled="returnItem || isOpen"
            clearable
            :rules="[(v) => !!v || 'Truck Type is required']"
            required
            @change="handleTruckTypeChange"
          >
            <template #item="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
              <span class="ml-1">
                {{ item && item.weight_limit ? `(${item.weight_limit} kg)` : '(Weight Limit Not Available)' }}
              </span>
            </template>
            <template #selection="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
              <span class="ml-1">
                {{ item && item.weight_limit ? `(${item.weight_limit} kg)` : '(Weight Limit Not Available)' }}
              </span>
            </template>
            <template slot="label">
              Truck Type<RedAsterisk />
            </template>
          </v-select>
        </v-col>
        <v-col
          cols="1"
          class="mt-4 pb-0"
        >
          <v-autocomplete
            v-model="item.trucks"
            :disabled="!truckTypeId || returnItem || isOpen"
            :items="trucks"
            :item-text="
              (item) =>
                `${item.name} (${item.truck_number ? item.truck_number : '-'})`
            "
            item-value="id"
            :loading="loadingTrucks"
            return-object
            clearable
            multiple
            :rules="[(v) => !!v && v.length > 0 || 'Truck Number is required']"
            required
          >
            <template #item="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
              <span class="ml-1">
                {{ item && item.truck_number ? `(${item.truck_number})` : '(Truck Number Not Available)' }}
              </span>
            </template>
            <template #selection="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
              <span class="ml-1">
                {{ item && item.truck_number ? `(${item.truck_number})` : '(Truck Number Not Available)' }}
              </span>
            </template>
            <template slot="label">
              Truck Number<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="3"
          class="mt-4 pb-0"
        >
          <v-autocomplete
            v-model="item.job_id"
            :items="jobs"
            :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
            item-value="id"
            :loading="loadingJobs"
            :disabled="returnItem || item.bill_of_lading_items.length > 0 || isOpen"
            :rules="[(v) => !!v || 'Job is required']"
            clearable
            :single-select="false"
            @change="handleJobChange"
            prepend-inner-icon="mdi-reload"
            @click:prepend-inner="getJobs()"
          >
            <template #selection="{ item }">
              <v-chip
                v-if="item.sub_class_color || item.sub_class_name"
                class="mt-1 mb-1 mr-3"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item && item.sub_class_color ? item.sub_class_color : 'white'"
              >
                {{ item && item.sub_class_name ? item.sub_class_name : '' }}
              </v-chip>
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
            <template #item="{ item }">
              <v-chip
                v-if="item.sub_class_name || item.sub_class_color"
                class="mt-1 mb-1 mr-3"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item && item.sub_class_color ? item.sub_class_color : 'white'"
              >
                {{ item && item.sub_class_name ? item.sub_class_name : '' }}
              </v-chip>
              <span>
                <span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span>
              </span>
            </template>
            <template v-if="loadingJobs" #label>
              Loading Jobs...
            </template>
            <template v-else #label>
              Job<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="returnItem"
          cols="3"
          class="mt-4 pb-0"
        >
          <v-text-field
            v-model="item.return_reason"
            :rules="[(v) => !!v || 'Return Reason is required', (v) => !!v && v.length <= 45 || 'Max 45 characters']"
            counter="45"
          >
            <template slot="label">
              Return Reason<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
        <v-col
          v-else
          cols="3"
          class="mt-4 pb-0"
        >
          <vuetify-google-autocomplete
            id="google"
            ref="google"
            v-model="item.ship_to_address"
            :disabled="returnItem || isOpen"
            :rules="[(v) => !!v || 'Ship To Address is required']"
            classname="form-control"
            :country="'ca'"
            @placechanged="getAddressData"
          >
            <template slot="label">
              Ship To Address<RedAsterisk />
            </template>
          </vuetify-google-autocomplete>
        </v-col>
        <v-col
          cols="auto"
          class="mt-4 pb-0"
        >
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div v-on="on">
                <v-btn
                  v-bind="attrs"
                  color="success"
                  outlined
                  @click.stop="installerInformationForm = true"
                >
                  <v-icon
                    small
                    class="mr-1"
                  >
                    fas fa-plus
                  </v-icon>
                  INSTLALLER
                </v-btn>
              </div>
            </template>
            <span> Installer Information </span>
          </v-tooltip>
        </v-col>

        <v-dialog
          v-model="installerInformationForm"
          max-width="500px"
        >
          <v-card>
            <v-card-title class="text-h5">
              Installer Information
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="item.installer_name"
                    :disabled="returnItem || isOpen"
                    counter="45"
                    maxlength="45"
                  >
                    <template slot="label">
                      Installer Name
                    </template>
                  </v-text-field>
                </v-col>
                  <v-col cols="12">
                    <VuePhoneNumberInput
                      v-model="item.installer_phone_number"
                      :disabled="returnItem || isOpen"
                      default-country-code="CA"
                    />
                  </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="installerInformationForm = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-spacer />
      <v-row>
        <v-col>
          <v-row align="center">
            <v-col class="pb-0">
              <span :style="{ color: '#000000', fontSize: '18px' }"
                >Notes</span
              >
            </v-col>
            <v-col v-if="item.id" class="text-end">
              <v-btn color="orange" outlined @click="openNoteForm">
                SEE ALL NOTES
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-textarea
                v-model="item.note"
                :disabled="item.notes && item.notes.length > 0"
                outlined
                rows="3"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <commercial-bill-of-lading-finished-good-form
        ref="finishedGoodForm"
        :finished-goods="allFinishedGoodsInBillOfLading"
        :finished-good-commercial-type-id-frame="finishedGoodCommercialTypeIdFrame"
        :finished-good-commercial-type-id-slab="finishedGoodCommercialTypeIdSlab"
      />
      <note-form v-show="false" ref="noteForm" />
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CommercialBillOfLadingExtraItemForm from '@/components/forms/commercialBillOfLadings/CommercialBillOfLadingExtraItemForm';
import CommercialBillOfLadingFinishedGoodForm from '@/components/forms/commercialBillOfLadings/CommercialBillOfLadingFinishedGoodForm';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import NoteForm from '@/components/forms/notes/NoteForm';
import VuePhoneNumberInput from 'vue-phone-number-input';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {
    CommercialBillOfLadingExtraItemForm,
    CommercialBillOfLadingFinishedGoodForm,
    VuetifyGoogleAutocomplete,
    NoteForm,
    VuePhoneNumberInput,
  },
  props: {
  },
  data: () => ({
    bolMode: null,
    bolModeDoor: 'door',
    bolModeWindow: 'window',
    item: null,
    itemDto: {
      // id: 0,
      job_id: null,
      truck_schedule_truck_id: null,
      bill_of_lading_items: [],
      bill_of_lading_extra_items: [],
      ship_to_address: null,
      return_reason: null,
      // delivery_number: null,
      truck_schedule_request_id: null,
      trucks: [],
      installer_name: '',
      installer_phone_number: '',
      note: null,
    },
    tagQr: null,
    truckTypeId: null,
    scheduledDeliveryId: null,

    truckTypes: [],
    trucks: [],
    jobs: [],
    extraItems: [],
    scheduledDeliveries: [],
    roles: [],
    // expandedItems: [],
    expandedDoorItems: [],
    expandedWindowItems: [],
    expandedSkidChildItems: [],

    expandAllPanels: false,
    loading: false,
    loadingTruckTypes: false,
    loadingTrucks: false,
    loadingJobs: false,
    loadingScheduledDeliveries: false,
    uomSwitch: true,
    returnItem: false,
    billOfLadingQr: false,
    isShippedState: false,
    isReceivedState: false,
    isReturnedState: false,
    isOpen: false,
    installerInformationForm: false,

    finishedGoodStatusIdShipped: 9,
    finishedGoodStatusIdReceived: 10,
    finishedGoodStatusIdToBeReturned: 11,
    finishedGoodStatusIdReturned: 12,
    finishedGoodStatusIdQuarantined: 13,
    billOfLadingStatusIdPending: 1,
    billOfLadingStatusIdShipped: 2,
    billOfLadingStatusIdReceived: 3,
    billOfLadingStatusIdReturned: 4,
    noteTypeIdCommercialBillOfLading: 13,
    userRoleIdAdmin: 3,
    inventoryClassIdComm: 6,
    finishedGoodCommercialTypeIdWindow: 1,
    finishedGoodCommercialTypeIdDoor: 2,
    finishedGoodCommercialTypeIdFrame: 3,
    finishedGoodCommercialTypeIdSlab: 4,
    productionScheduleStatusIdInProgress: 1,
    jobSubClassIdCommDoors: 7,

    timeoutId: null,
    finishedGoodStatusShipped: {
      code: 'SHIPPED',
      color: '#FBC02D',
      id: 9,
      name: 'SHIPPED',
    },
    finishedGoodStatusReceived: {
      code: 'RECEIVED',
      color: '#388E3C',
      id: 10,
      name: 'RECEIVED',
    },
    finishedGoodStatusToBeReturned: {
      code: 'TO BE RETURNED',
      color: '#B21CB7',
      id: 11,
      name: 'TO BE RETURNED',
    },
    tableHeight: 570,
    topSpaceHeight: 240,
  }),
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    isAdmin () {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    headers() {
      const headers = [
        { text: 'Tag ID', value: 'finished_good.tag_id', sortable: false },
        {
          text: 'Tag #', fullText: 'Window Number on Drawing', value: 'finished_good.tag_number', sortable: false,
        },
        {
          text: 'Sequence #', value: 'sequence_number', sortable: false,
        },
        { text: 'Work Order', value: 'finished_good.work_order', sortable: false },
        { text: 'Reference', value: 'finished_good.floor_number', sortable: false },
        { text: 'Type', value: 'finished_good.type', sortable: false },
        {
          text: 'Square Feet', value: 'finished_good.sqft', align: 'end', width: '6%', sortable: false,
        },
        {
          text: 'Width (inches)', value: 'finished_good.width', align: 'end', width: '6%', sortable: false,
        },
        {
          text: 'Height (inches)', value: 'finished_good.height', align: 'end', width: '6%', sortable: false,
        },
        {
          text: 'Length (inches)', value: 'finished_good.length', align: 'end', width: '6%', sortable: false,
        },
        {
          text: 'Weight (kg)', value: 'finished_good.weight', align: 'end', width: '6%', sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          align: 'center',
          width: '10%',
          sortable: false,
        },
      ];

      if (this.item.job && this.item.job.sub_class_id === this.jobSubClassIdCommDoors && this.businessRulesGetBoolean('Streamline Door Scanning')) {
        headers.splice(6, 0, {
          text: 'Total Components', value: 'total_components', align: 'center', sortable: false,
        });
      }

      if (this.hasReturnedItem) {
        headers.push({
          text: 'Return Reason',
          value: 'return_reason',
          sortable: false,
        });
      }

      if (!this.billOfLadingQr) {
        headers.push({
          text: 'Actions',
          value: 'actions',
          align: 'end',
          width: '5%',
          sortable: false,
        });
      }

      return headers;
    },

    doorComponentHeaders() {
      const headers = [
        { text: '', value: 'data-table-expand', width: '1%', sortable: false },
        { text: 'Tag ID', value: 'finished_good.tag_id', sortable: false },
        {
          text: 'Tag #', fullText: 'Window Number on Drawing', value: 'finished_good.tag_number', sortable: false,
        },
        {
          text: 'Sequence #', value: 'sequence_number', sortable: false,
        },
        { text: 'Work Order', value: 'finished_good.work_order', sortable: false },
        { text: 'Reference', value: 'finished_good.floor_number', sortable: false },
        { text: 'Type', value: 'finished_good.type', sortable: false },
        {
          text: 'Die',
          value: 'finished_good.aluminum_die.code',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Int. Color',
          value: 'finished_good.int_color.code',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Ext. Color',
          value: 'finished_good.ext_color.code',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Length (inches)', value: 'finished_good.length', align: 'end', width: '10%', sortable: false,
        },
        {
          text: 'Weight (kg)', value: 'finished_good.weight', align: 'end', width: '10%', sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          align: 'center',
          width: '10%',
          sortable: false,
        },
      ];

      return headers;
    },

    windowHeaders() {
      return [
        { text: '', value: 'data-table-expand', width: '1%', sortable: false },
        { text: 'Type', value: 'type', width: '10%', sortable: false },
        { text: 'Number/Tag', value: 'number_or_tag', width: '10%', sortable: false },
        { text: 'Qty', value: 'quantity', align: 'center', width: '5%', sortable: false },
        {
          text: 'Weight (kg)',
          value: 'weight',
          align: 'end',
          width: '10%',
          sortable: false,
        },
        { text: 'Actions', value: 'actions', align: 'end', width: '55%', sortable: false },
      ];
    },

    windowFinishedGoodAndBundleSubHeaders() {
      return [
        { text: 'Tag ID', value: 'finished_good.tag_id', sortable: false, width: '10%' },
        {
          text: 'Tag #',
          fullText: 'Window Number on Drawing',
          value: 'finished_good.tag_number',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Sequence #',
          value: 'finished_good.sequence_number',
          sortable: false,
          width: '5%',
        },
        { 
          text: 'Type',
          value: 'finished_good.type',
          sortable: false,
          width: '5%',
        },
        {
          text: 'Die',
          value: 'finished_good.aluminum_die.code',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Int. Color',
          value: 'finished_good.int_color.code',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Ext. Color',
          value: 'finished_good.ext_color.code',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Length (inches)',
          value: 'finished_good.length',
          align: 'end',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Weight (kg)',
          value: 'finished_good.weight',
          align: 'end',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          align: 'center',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'end',
          sortable: false,
          width: '10%',
        },
      ];
    },

    windowSkidChildHeaders() {
      return [
        { text: '', value: 'data-table-expand', width: '1%', sortable: false },
        { text: 'Type', value: 'type', width: '10%', sortable: false },
        { text: 'Number/Tag', value: 'number_or_tag', width: '10%', sortable: false },
        { text: 'Qty', value: 'quantity', align: 'center', width: '5%', sortable: false },
        {
          text: 'Weight (kg)',
          value: 'weight',
          align: 'end',
          width: '10%',
          sortable: false,
        },
        { text: '', value: '', width: '55%', sortable: false },
      ];
    },

    doorTableItems() {
      //if "Streamlined Door Scanning" business rule is enabled then do the grouping, otherwise just return the items as they are
      if (!this.businessRulesGetBoolean('Streamline Door Scanning')) {
        return this.item.bill_of_lading_items;
      }

      if (this.item && this.item.job && this.item.job.sub_class_id !== this.jobSubClassIdCommDoors) {
        return this.item.bill_of_lading_items;
      }

      //if the bill of lading items contains a bundle or a skid then just return the items as they are, since the grouping logic below is only meant to group door components with their respective door
      const hasBundle = this.item.bill_of_lading_items.some(item => item.commercial_bundle);
      const hasSkid = this.item.bill_of_lading_items.some(item => item.commercial_skid);
      if (hasBundle || hasSkid) {
        return this.item.bill_of_lading_items;
      }

      //below is logic for grouping door components with their respective door based on tag_number, this is needed to support the "Streamline Door Scanning"
      const groups = new Map();

      this.item.bill_of_lading_items.forEach(row => {
        const fg = row.finished_good;
        const key = fg.tag_number;

        if (!groups.has(key)) {
          groups.set(key, {
            doorRow: null,
            frames: [],
          });
        }

        const group = groups.get(key);

        if (fg.type_id === 2) {
          group.doorRow = {
            ...row,
            frames: [],
          };
        } else {
          group.frames.push(row);
        }
      });

      return Array.from(groups.values())
        .filter(group => group.doorRow)
        .map(group => {
          return {
            ...group.doorRow,
            frames: group.frames,
          };
        });
    },

    windowTableItems() {
      if (!this.item || !this.item.bill_of_lading_items) return [];

      const groupedItems = [];
      const finishedGoodGroups = {};

      this.item.bill_of_lading_items.forEach((item) => {
        if (item.finished_good) {
          const tagNumber = item.finished_good.tag_number || item.finished_good.tag_id;

          if (!finishedGoodGroups[tagNumber]) {
            finishedGoodGroups[tagNumber] = {
              is_finished_good_group: true,
              temp_id: `fg-group-${tagNumber}`,
              tag_number: tagNumber,
              finished_goods: [],
            };

            groupedItems.push(finishedGoodGroups[tagNumber]);
          }

          finishedGoodGroups[tagNumber].finished_goods.push(item.finished_good);
          return;
        }

        groupedItems.push(item);
      });

      return groupedItems;
    },

    hasReturnedItem() {
      if (!this.item || !this.item.bill_of_lading_items || this.item.bill_of_lading_items.length === 0) {
        return false;
      }

      return this.item.bill_of_lading_items.some(
        (item) => item.status_id === this.finishedGoodStatusIdReturned,
      );
    },
    allFinishedGoodsInBillOfLading() {
      if (!this.item || !this.item.bill_of_lading_items) return [];

      const finishedGoods = [];

      this.item.bill_of_lading_items.forEach((item) => {
        if (item.finished_good) {
          finishedGoods.push(item.finished_good);
        }

        if (item.commercial_bundle && item.commercial_bundle.commercial_bundle_items) {
          item.commercial_bundle.commercial_bundle_items.forEach((bundleItem) => {
            if (bundleItem.finished_good) {
              finishedGoods.push(bundleItem.finished_good);
            }
          });
        }

        if (item.commercial_skid && item.commercial_skid.commercial_skid_items) {
          item.commercial_skid.commercial_skid_items.forEach((skidItem) => {
            if (skidItem.finished_good) {
              finishedGoods.push(skidItem.finished_good);
            }

            if (skidItem.commercial_bundle && skidItem.commercial_bundle.commercial_bundle_items) {
              skidItem.commercial_bundle.commercial_bundle_items.forEach((bundleItem) => {
                if (bundleItem.finished_good) {
                  finishedGoods.push(bundleItem.finished_good);
                }
              });
            }
          });
        }
      });

      return finishedGoods;
    },
  },
  watch: {
  },
  created() {
    this.item = JSON.parse(JSON.stringify(this.itemDto));
    this.init();
    this.roles = this.user.roles.map((x) => x.id);
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      if (this.truckTypes.length === 0) {
        this.getTruckTypes();
      }
      if (this.jobs.length === 0) {
        this.getJobs();
      }
      // this.getPoItems();
    },

    isDoorMode() {
      return this.bolMode === this.bolModeDoor;
    },

    isWindowMode() {
      return this.bolMode === this.bolModeWindow;
    },

    isDoorFinishedGood(finishedGood) {
      return !!finishedGood
        && finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor;
    },

    getModeFromFinishedGood(finishedGood) {
      if (!finishedGood) return null;

      if (this.isDoorFinishedGood(finishedGood)) {
        return this.bolModeDoor;
      }

      return this.bolModeWindow;
    },

    canScanIntoMode(mode) {
      if (!mode) return false;
      if (!this.bolMode) return true;
      return this.bolMode === mode;
    },

    setBolMode(mode) {
      //Door mode is set when job is Comm Doors AND Streamline Door Scanning is enabled
      //Otherwise Window mode is set
      if (!this.bolMode && mode) {
        this.bolMode = mode;
      }
    },

    resetBolUiState() {
      this.bolMode = null;
      this.expandAllPanels = false;
      this.expandedDoorItems = [];
      this.expandedWindowItems = [];
      this.expandedSkidChildItems = [];
    },

    async open(id = null, returnItem = false, billOfLadingQr = false, isOpen = false) {
      this.$bus.$emit('loading');
      this.$refs.dialogBox.open(); // for some reason need to add await, otherwise user's location won't be set in v-autocomplete by default
      this.resetBolUiState();
      this.returnItem = returnItem;
      this.billOfLadingQr = billOfLadingQr;
      this.isOpen = isOpen;
      if (this.billOfLadingQr) {
        id = this.extractIdFromQrCode(id);
        if (!id) {
          this.$refs.dialogBox.close();
          this.$bus.$emit('loading-stop');
          this.$bus.$emit('showError', 'QR code is incorrect');
          return;
        }
      }
      if (this.jobs.length === 0) {
        this.getJobs();
      }
      if (id) {
        const res = await this.get(id);
        if (!res) {
          this.$refs.dialogBox.close();
          this.$bus.$emit('loading-stop');
          this.$bus.$emit('showError', 'Bill of lading not found');
          return;
        }

        //get associated pick list items from here? or get it from the server when reading the bill of lading
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemDto));
      }
      this.setFormState();
      this.$bus.$emit('loading-stop');
      this.$nextTick(async () => {
        if (this.$refs.billOfLadingExtraItemForm) {
          this.$refs.billOfLadingExtraItemForm.items = [];
          this.$refs.billOfLadingExtraItemForm.getExtraItemTypes();
          this.$refs.billOfLadingExtraItemForm.getColors();
          this.$refs.billOfLadingExtraItemForm.getUoms();
        }
      });
    },

    setFormState() {
      if (!this.item) return;
      this.isShippedState = false;
      this.isReceivedState = false;
      this.isReturnedState = false;
      if (this.item.status_id === this.billOfLadingStatusIdShipped) {
        this.isShippedState = true;
      } else if (this.item.status_id === this.billOfLadingStatusIdReceived) {
        this.isReceivedState = true;
      } else if (this.item.status_id === this.billOfLadingStatusIdReturned) {
        this.isReturnedState = true;
      }
    },

    async get(id) {
      const submitModel = {
        filters: {
          id,
        },
        with: ['items']
      };
      const res = await this.$api.commercialBillOfLading.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.$bus.$emit('showError', 'Unable to retrieve bill of lading');
        return false;
      }
      const firstIndex = 0;
      this.item = JSON.parse(JSON.stringify(res.data[firstIndex]));
      this.setBolModeFromExistingItems();

      this.truckTypeId = this.item.trucks[0] && this.item.trucks[0].truck_type_id ? this.item.trucks[0].truck_type_id : null;

      if (this.item.bill_of_lading_items.length > 0) {
        this.item.bill_of_lading_items.forEach((item, index) => {
          this.item.bill_of_lading_items[index].index = index;
        });
      }

      this.getTrucks();
      // get Scheduled Deliveries based on the item's job_id
      // await this.getScheduledDeliveries(this.item.job_id);
      // this.setScheduledDelivery();

      this.$nextTick(async () => {
        if (this.$refs.billOfLadingExtraItemForm) {
          this.$refs.billOfLadingExtraItemForm.get(id);
          this.$refs.billOfLadingExtraItemForm.isOpen = true;
        }
      });

      return true;
    },

    setBolModeFromExistingItems() {
      if (!this.item || !this.item.bill_of_lading_items || this.item.bill_of_lading_items.length === 0) {
        this.bolMode = null;
        return;
      }

      // if there are bundles or skids, set to window mode since door mode grouping logic doesn't work with bundles and skids
      if (this.item.bill_of_lading_items.some(item => item.commercial_bundle || item.commercial_skid)) {
        this.bolMode = this.bolModeWindow;
        return;
      }

      //set it by the job if job exists
      if (this.item.job) {
        if (
          this.item.job.sub_class_id === this.jobSubClassIdCommDoors &&
          this.businessRulesGetBoolean('Streamline Door Scanning')
        ) {
          this.bolMode = this.bolModeDoor;
          return;
        } else {
          this.bolMode = this.bolModeWindow;
          return;
        }
      }

      const firstItem = this.item.bill_of_lading_items[0];

      if (firstItem.commercial_bundle || firstItem.commercial_skid) {
        this.bolMode = this.bolModeWindow;
        return;
      }

      if (firstItem.finished_good) {
        this.bolMode = this.getModeFromFinishedGood(firstItem.finished_good);
        return;
      }

      this.bolMode = null;
    },

    setScheduledDelivery() {
      const scheduledDelivery = this.scheduledDeliveries.find((scheduledDelivery) => scheduledDelivery.requests.some((request) => request.id === this.item.truck_schedule_request_id));

      if (scheduledDelivery) {
        this.scheduledDeliveryId = scheduledDelivery.id;
      }
    },

    async getTruckTypes() {
      this.loadingTruckTypes = true;
      const submitModel = {
        filters: {},
      };
      const res = await this.$api.truckScheduleTruckType.read(submitModel);
      if (!res || !res.length) {
        this.$bus.$emit('showError', 'Unable to retrieve truck types');
        this.loadingTruckTypes = false;
        return;
      }

      this.truckTypes = res;

      this.loadingTruckTypes = false;
    },

    async getTrucks() {
      this.loadingTrucks = true;

      const submitModel = {
        filters: {
          truck_type_id: this.truckTypeId,
        },
      };

      const res = await this.$api.truckScheduleTruck.read(submitModel);
      if (!res) {
        this.$bus.$emit('showError', 'Unable to retrieve trucks');
        this.loadingTrucks = false;
        return;
      }

      this.trucks = res;

      this.loadingTrucks = false;
    },

    async getJobs() {
      this.loadingJobs = true;
      const submitModel = {
        filters: {
          inventory_class_id: this.inventoryClassIdComm,
          // is_sub_class: 1
          is_manual: 0,
        },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.jobs = res;
      this.loadingJobs = false;
    },

    async getScheduledDeliveries(jobId = null, truckScheduleRequestId = null) {
      // get scheduled deliveries that have the same jobId and set as scheduledDeliveries
      this.loadingScheduledDeliveries = true;
      const submitModel = {
        filters: {
          job_id: jobId,
          truck_schedule_request_id: truckScheduleRequestId,
        },
      };
      const res = await this.$api.truckScheduleSlot.read(submitModel);
      if (!res) {
        this.$bus.$emit('showError', 'Unable to retrieve scheduled deliveries');
        this.loadingScheduledDeliveries = false;
        return;
      }
      this.scheduledDeliveries = res;
      this.loadingScheduledDeliveries = false;
    },

    async submit() {
      if (!this.returnItem && this.item.truck_schedule_truck_id && this.isTruckOverweight()) {
        this.$bus.$emit('showError', 'Truck is overweight');
        return;
      }
      this.$bus.$emit('loading');
      let res = false;

      if (this.returnItem) {
        res = await this.$api.commercialBillOfLading.store(this.item, 'return-window');
        if (!res) {
          this.$bus.$emit('loading-stop');
          this.$bus.$emit('showError', 'Error returning windows');
          return false;
        }
      } else {
        if (this.$refs.billOfLadingExtraItemForm) {
          this.item.bill_of_lading_extra_items = this.$refs.billOfLadingExtraItemForm.items;
        }

        let billOfLadingId = this.item.id;

        if (this.item.id) {
          res = await this.$api.commercialBillOfLading.update(this.item);
        } else {
          res = await this.$api.commercialBillOfLading.store(this.item);
          billOfLadingId = res;
        }
        if (!res) {
          this.$bus.$emit('loading-stop');
          this.$bus.$emit('showError', 'Error submitting bill of lading');
          return false;
        }

        if (this.item.note && this.item.note.trim().length > 0 && this.isNewNote(this.item.note)) {
          const note = {
            text: this.item.note,
            record_id: billOfLadingId,
            type_id: this.noteTypeIdCommercialBillOfLading,
          };
          const noteRes = await this.$api.note.store(note);
          if (!noteRes) {
            this.$bus.$emit(
              'showError',
              'Error adding note to bill of lading',
            );
            this.$bus.$emit('loading');
            return false;
          }
        }
      }

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return true;
    },

    async submitQr() {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${this.isShippedState ? 'receive' : 'undo receive'} this bill of lading?`,
      });
      if (!confirm) return false;
      this.$bus.$emit('loading');
      const res = await this.$api.commercialBillOfLading.get(`toggle/${this.item.id}`);
      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      return true;
    },

    handleExtraItemsChanged(newItems) {
      
    },

    handleTruckTypeChange() {
      this.getTrucks();
      this.item.trucks = [];
      // this.item.truck_schedule_truck_id = null;
    },

    handleScheduledDeliveryChange(scheduledDeliveryId) {
      // find the scheduled delivery in this.scheduledDeliveries using the scheduleDeliveryId and find the truck request in this.scheduledDeliveries.requests that has the same job
      // take that truck request id and set it as this.item.truck_request_id;
      if (!scheduledDeliveryId) {
        this.item.truck_schedule_request_id = null;
        return;
      }
      const scheduledDelivery = this.scheduledDeliveries.find((x) => x.id === scheduledDeliveryId);
      if (!scheduledDelivery) {
        this.item.truck_schedule_request_id = null;
        this.$bus.$emit('showError', 'Something went wrong... Scheduled delivery not found');
        return;
      }
      const truckRequest = scheduledDelivery.requests.find((x) => x.job_id === this.item.job_id);
      if (!truckRequest) {
        this.item.truck_schedule_request_id = null;
        this.$bus.$emit('showError', 'Something went wrong... Truck request with the current job not found');
        return;
      }
      this.item.truck_schedule_request_id = truckRequest.id;
    },

    handleJobChange() {
      if (this.item.job_id !== null) {
        //get scheduled deliveries with this job
        // this.getScheduledDeliveries(this.item.job_id);
      }
    },

    handleTagAction() {
      this.returnItem ? this.returnTag() : this.handleAddTag();
    },

    getInputType(value) {
      if (!value || typeof value !== 'string') return 'invalid';

      const trimmed = value.trim();

      const isBundle = /^BN\d+$/.test(trimmed);
      if (isBundle) return 'bundle';

      const isSkid = /^S\d+$/.test(trimmed);
      if (isSkid) return 'skid';

      const isFinishedGood = /^[A-Za-z0-9.-]+$/.test(trimmed);
      if (isFinishedGood) return 'finished_good';

      return 'invalid';
    },

    async handleAddTag() {
      const inputType = this.getInputType(this.tagQr);
      if (inputType === 'skid') {
        this.addSkid();
      } else if (inputType === 'bundle') {
        this.addBundle();
      } else if (inputType === 'finished_good') {
        this.addTag();
      } else {
        this.$bus.$emit('showError', 'Invalid QR code');
        this.tagQr = null;
      }
    },

    async addSkid() {
      this.$bus.$emit('loading');

      // Validation checks:
      // Already scanned (skid already on bill of lading) → block
      // Same job validation (same rule as FG; first scan sets job)
      // If skid is already assigned to a Bill Of Lading → block

      // If skid contains FGs assigned to a bill of lading → block (not sure if needed since we are already blocking when FGs are added to skids)
      // If skid contains invalid FG statuses (Shipped, Received, Quarantined) → block (not sure if needed since we are already blocking when FGs are added to skids)

      const submitModel = {
        filters: {
          skid_number: this.tagQr,
        },
      };
      const res = await this.$api.commercialSkid.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Skid is not found or incorrect', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const skid = res.data[0];

      if (!this.canScanIntoMode(this.bolModeWindow)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Cannot scan a skid into a door bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      //if is door job and streamline door scanning is enabled, then block scanning skids into the bill of lading
      if (
        this.item.job &&
        this.item.job.sub_class_id === this.jobSubClassIdCommDoors &&
        this.businessRulesGetBoolean('Streamline Door Scanning')
      ) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Cannot scan a skid into a door job bill of lading while Streamline Door Scanning is enabled', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      this.setBolMode(this.bolModeWindow);

      if (this.isSkidScanned(skid)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Skid has already been scanned', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (!this.isSkidSameJob(skid)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Skid is from a different job', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const billOfLadingId = await this.isSkidAssignedToBillOfLading(skid);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if skid is assigned to a bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');  
        this.$bus.$emit('showError', `Skid is under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      this.item.bill_of_lading_items.unshift({ commercial_skid: skid, temp_id: Date.now(), });

      this.expandedWindowItems.push(this.item.bill_of_lading_items[0]);

      if (this.item.job_id === null) {
        this.item.job_id = skid.job_id ? skid.job_id : null;
      }

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.tagQr = null;
    },

    async addBundle() {
      this.$bus.$emit('loading');

      // Validation checks:
      // Already scanned (bundle already on bill of lading) → block
      // Same job validation (same rule as FG; first scan sets job)
      // If bundle is already assigned to a Bill Of Lading → block
      // If bundle is already assigned to a skid → block because they should only be able to scan the skid which contains the bundle, not the bundle itself

      // If bundle contains FGs assigned to a bill of lading → block (not sure if needed since we are already blocking when FGs are added to bundles)
      // If bundle contains invalid FG statuses (Shipped, Received, Quarantined) → block (not sure if needed since we are already blocking when FGs are added to bundles)

      const submitModel = {
        filters: {
          bundle_number: this.tagQr,
        },
      };
      const res = await this.$api.commercialBundle.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Bundle is not found or incorrect', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const bundle = res.data[0];

      if (!this.canScanIntoMode(this.bolModeWindow)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Cannot scan a bundle into a door bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      //if is door job and streamline door scanning is enabled, then block scanning bundles into the bill of lading
      if (
        this.item.job &&
        this.item.job.sub_class_id === this.jobSubClassIdCommDoors &&
        this.businessRulesGetBoolean('Streamline Door Scanning')
      ) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Cannot scan a bundle into a door job bill of lading while Streamline Door Scanning is enabled', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      this.setBolMode(this.bolModeWindow);

      if (this.isBundleScanned(bundle)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Bundle has already been scanned', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (!this.isBundleSameJob(bundle)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Bundle is from a different job', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const billOfLadingId = await this.isBundleAssignedToBillOfLading(bundle);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if bundle is assigned to a bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');  
        this.$bus.$emit('showError', `Bundle is under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const skidNumber = await this.isBundleAssignedToSkid(bundle);
      if (skidNumber === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if bundle is assigned to a skid', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (skidNumber) {
        this.$bus.$emit('loading-stop');  
        this.$bus.$emit('showError', `Bundle is under - Skid #${skidNumber}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      this.item.bill_of_lading_items.unshift({ commercial_bundle: bundle, temp_id: Date.now(), });

      this.expandedWindowItems.push(this.item.bill_of_lading_items[0]);

      if (this.item.job_id === null) {
        this.item.job_id = bundle.job_id ? bundle.job_id : null;
      }

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.tagQr = null;
    },

    async addTag() {
      this.$bus.$emit('loading');

      //check if tag is scanned already in the bill of lading before calling the api
      if (this.item.bill_of_lading_items.some((item) => item.finished_good?.tag_id === this.tagQr)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been scanned in this bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const submitModel = {
        filters: {
          tag_id: this.tagQr,
        },
      };
      const res = await this.$api.finishedGoodCommercial.read(submitModel, null, 'read-bill-of-lading');
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is not found or incorrect', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (this.businessRulesGetBoolean('Streamline Door Scanning') && this.hasDoor(res)) {
        this.handleDoorTag(res);
      } else {
        this.handleTag(res[0]);
      }

      if (this.item.job_id !== null) {
        // get scheduled deliveries with this job
        // this.getScheduledDeliveries(this.item.job_id);
      }
    },

    async handleDoorTag(finishedGoods) {
      const groupedErrors = {};
      const billOfLadingItems = [];
      this.setBolMode(this.bolModeDoor);

      const addError = (reason, finishedGood) => {
        const tagId = finishedGood.tag_id || finishedGood.id;

        if (!groupedErrors[reason]) {
          groupedErrors[reason] = [];
        }

        groupedErrors[reason].push(tagId);
      };

      const buildErrorMessage = () => {
        return Object.entries(groupedErrors)
          .map(([reason, tags]) => `${reason} (${tags.length}):\n- ${tags.join(', ')}`)
          .join('\n\n');
      };

      // if only one finished good in finished goods array, and it's a door then return error message that door cannot be added
      if (finishedGoods.length === 1) {
        if (finishedGoods[0].type_id === this.finishedGoodCommercialTypeIdDoor) {
          this.$bus.$emit('loading-stop');
          this.$bus.$emit(
            'showError',
            'Tag is a door - unable to add to commercial bill of lading',
            null,
            'xl',
            2500
          );
          this.tagQr = null;
          return;
        }
      }

      for (const finishedGood of finishedGoods) {
        if (!this.isSameJob(finishedGood)) {
          addError('Different job', finishedGood);
          continue;
        }

        let billOfLadingId = await this.isTagAssignedToPendingBillOfLading(finishedGood);
        if (billOfLadingId === undefined) {
          addError('Could not verify pending bill of lading', finishedGood);
          continue;
        }

        if (billOfLadingId) {
          addError(`Under Bill Of Lading #${billOfLadingId}`, finishedGood);
          continue;
        }

        billOfLadingId = await this.isTagAssigned(finishedGood);
        if (billOfLadingId === undefined) {
          addError('Could not verify assigned bill of lading', finishedGood);
          continue;
        }

        if (billOfLadingId) {
          addError(`Under Bill Of Lading #${billOfLadingId}`, finishedGood);
          continue;
        }

        if (
          finishedGood.commercial_schedule &&
          finishedGood.commercial_schedule.status_id !== this.productionScheduleStatusIdInProgress
        ) {
          addError('Commercial schedule not In Progress', finishedGood);
          continue;
        }

        if (finishedGood.status_id === this.finishedGoodStatusIdShipped) {
          addError('Already shipped', finishedGood);
          continue;
        }

        if (finishedGood.status_id === this.finishedGoodStatusIdReceived) {
          addError('Already received', finishedGood);
          continue;
        }

        if (finishedGood.status_id === this.finishedGoodStatusIdQuarantined) {
          addError('Quarantined', finishedGood);
          continue;
        }

        if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow) {
          addError('Is a window and cannot be added', finishedGood);
          continue;
        }

        if (!finishedGood.type) {
          addError('Type is not set', finishedGood);
          continue;
        }

        billOfLadingItems.unshift({
          finished_good: finishedGood,
          status: finishedGood.status,
        });

        if (this.item.job_id === null) {
          this.item.job_id =
            finishedGood.commercial_schedule && finishedGood.commercial_schedule.job_id
              ? finishedGood.commercial_schedule.job_id
              : null;
          this.item.job = this.jobs.find((job) => job.id === this.item.job_id) || null;
        }
      }

      this.item.bill_of_lading_items = [...billOfLadingItems, ...this.item.bill_of_lading_items];

      this.$bus.$emit('loading-stop');
      this.tagQr = null;

      if (Object.keys(groupedErrors).length > 0) {
        this.$bus.$emit(
          'showError',
          buildErrorMessage(),
          null,
          'xl',
          5000
        );
      } else {
        this.$bus.$emit(
          'showSuccess',
          'Door and associated frames added successfully'
        );
      }
    },

    async handleTag(finishedGood) {
      // Validation checks:
      // Validates tag belongs to the same job
      // Checks if tag is assigned to a pending bill of lading
      // Handles error if pending assignment check fails (undefined)
      // Checks if tag is assigned to any bill of lading
      // Handles error if assignment check fails (undefined)
      // Ensures commercial schedule status is In Progress
      // Blocks if status is Shipped
      // Blocks if status is Received
      // Blocks if status is Quarantined
      // Blocks if type is Window or Door
      // Ensures finished good has a valid type (for weight calculation)

      const mode = this.bolModeWindow;

      if (!this.canScanIntoMode(mode)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit(
          'showError',
          this.isDoorMode()
            ? 'Cannot scan a window item into a door bill of lading'
            : 'Cannot scan a door into a window bill of lading',
          null,
          'xl',
          2500
        );
        this.tagQr = null;
        return;
      }

      this.setBolMode(mode);

      if (!this.isSameJob(finishedGood)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is from a different job', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      let billOfLadingId = await this.isTagAssignedToPendingBillOfLading(finishedGood);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to another bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', `Tag is under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      billOfLadingId = await this.isTagAssigned(finishedGood);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to another bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', `Window is under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      // if (finishedGood.commercial_schedule == null || finishedGood.commercial_schedule == undefined) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit('showError', 'Finished Good is not part of a commercial schedule', null, 'xl', 2500);
      //   this.tagQr = null;
      //   return;
      // }
      if (finishedGood.commercial_schedule && finishedGood.commercial_schedule.status_id !== this.productionScheduleStatusIdInProgress) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Finished Good\'s Commercial Schedule status is not set to In Progress (Current)', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdShipped) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been shipped', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdReceived) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been received', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdQuarantined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has been quarantined', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow || finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor) {
        this.$bus.$emit('loading-stop');
        const item = finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow ? 'window' : 'door';
        this.$bus.$emit('showError', `Tag is a ${item} - unable to add to commercial bill of lading`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (!finishedGood.type) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Finished good type is not set - unable to calculate weight', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      this.item.bill_of_lading_items.unshift({ finished_good: finishedGood, status: finishedGood.status, temp_id: Date.now(), });
      this.expandedWindowItems.push(this.item.bill_of_lading_items[0]);

      if (this.item.job_id === null) {
        this.item.job_id = finishedGood.commercial_schedule && finishedGood.commercial_schedule.job_id ? finishedGood.commercial_schedule.job_id : null;
        this.item.job = this.jobs.find((job) => job.id === this.item.job_id) || null;
      }
      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.tagQr = null;
    },

    async returnTag() {
      this.$bus.$emit('loading');
      const submitModel = {
        filters: {
          tag_id: this.tagQr,
        },
      };
      const res = await this.$api.finishedGoodCommercial.read(submitModel, null, 'read-bill-of-lading');
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is not found or incorrect', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (this.businessRulesGetBoolean('Streamline Door Scanning') && this.hasDoor(res)) {
        this.handleReturnDoorTag(res);
      } else {
        this.handleReturnTag(res[0]);
      }
    },

    async handleReturnTag(finishedGood) {
      if (this.isReturned(finishedGood)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been returned', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      let billOfLadingId = await this.isTagAssignedToPendingBillOfLading(finishedGood);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to a pending bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', `Window is in PENDING state under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      billOfLadingId = await this.isTagAssigned(finishedGood);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to a bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (!billOfLadingId) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Window has not been assigned to a Bill Of Lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (
        this.item.bill_of_lading_items.length > 0
        && !this.isSameBillOfLading(billOfLadingId)
      ) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Window is from a different Bill Of Lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      
      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow || finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor) {
        this.$bus.$emit('loading-stop');
        const itemType = finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow ? 'window' : 'door';
        this.$bus.$emit('showError', `Tag is a ${itemType} - unable to add to commercial bill of lading`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (!this.item.id) {
        const res = await this.get(billOfLadingId);
        if (!res) {
          this.$bus.$emit('loading-stop');
          this.$bus.$emit('showError', 'Error loading bill of lading for this tag', null, 'xl', 2500);
          this.tagQr = null;
          return;
        }
      }

      const billOfLadingItemIndex = this.item.bill_of_lading_items.findIndex((x) => x.finished_good_commercial_id === finishedGood.id);
      this.$set(this.item.bill_of_lading_items[billOfLadingItemIndex], 'is_return', 1);
      // set old status to current status
      this.item.bill_of_lading_items[billOfLadingItemIndex].old_status = this.item.bill_of_lading_items[billOfLadingItemIndex].status;
      this.setBillOfLadingItemStatus(billOfLadingItemIndex, this.finishedGoodStatusIdToBeReturned);

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.tagQr = null;
    },

    async handleReturnDoorTag(finishedGoods) {
      const groupedErrors = {};
      const billOfLadingItems = [];
      let billOfLadingId = null;

      const addError = (reason, finishedGood) => {
        const tagId = finishedGood.tag_id || finishedGood.id;

        if (!groupedErrors[reason]) {
          groupedErrors[reason] = [];
        }

        groupedErrors[reason].push(tagId);
      };

      const buildErrorMessage = () => {
        return Object.entries(groupedErrors)
          .map(([reason, tags]) => `${reason} (${tags.length}):\n- ${tags.join(', ')}`)
          .join('\n\n');
      };

      // if only one finished good in finished goods array, and it's a door then return error message that door cannot be added
      if (finishedGoods.length === 1) {
        if (finishedGoods[0].type_id === this.finishedGoodCommercialTypeIdDoor) {
          this.$bus.$emit('loading-stop');
          this.$bus.$emit(
            'showError',
            'Tag is a door - unable to add to commercial bill of lading',
            null,
            'xl',
            2500
          );
          this.tagQr = null;
          return;
        }
      }

      for (const finishedGood of finishedGoods) {
        if (this.isReturned(finishedGood)) {
          addError('Already returned', finishedGood);
          continue;
        }

        let existingPendingBillOfLadingId = await this.isTagAssignedToPendingBillOfLading(finishedGood);
        if (existingPendingBillOfLadingId === undefined) {
          addError('Could not verify pending bill of lading', finishedGood);
          continue;
        }
        if (existingPendingBillOfLadingId) {
          addError(`In PENDING state under Bill Of Lading #${existingPendingBillOfLadingId}`, finishedGood);
          continue;
        }

        let assignedBillOfLadingId = await this.isTagAssigned(finishedGood);
        if (assignedBillOfLadingId === undefined) {
          addError('Could not verify if assigned to existing bill of lading', finishedGood);
          continue;
        }

        if (!assignedBillOfLadingId) {
          addError('Has not been assigned to a bill of lading', finishedGood);
          continue;
        }

        if (this.item.bill_of_lading_items.length > 0 && !this.isSameBillOfLading(assignedBillOfLadingId)) {
          addError('From a different bill of lading', finishedGood);
          continue;
        }

        billOfLadingItems.unshift({
          finished_good: finishedGood,
          status: finishedGood.status,
        });

        billOfLadingId = assignedBillOfLadingId;
      }

      if (!this.item.id) {
        const res = await this.get(billOfLadingId);
        if (!res) {
          this.$bus.$emit('loading-stop');
          this.$bus.$emit('showError', 'Error loading bill of lading for this tag', null, 'xl', 2500);
          this.tagQr = null;
          return;
        }
      }

      //for each bill of lading item in billOfLadingItems
      //find the index of that item in this.item.bill_of_lading_items
      //set is_return to 1 and old_status to the current status of the item and set the status to finishedGoodStatusIdToBeReturned
      billOfLadingItems.forEach((billOfLadingItem) => {
        const billOfLadingItemIndex = this.item.bill_of_lading_items.findIndex((x) => x.finished_good_commercial_id === billOfLadingItem.finished_good.id);
        this.$set(this.item.bill_of_lading_items[billOfLadingItemIndex], 'is_return', 1);
        // set old status to current status
        this.item.bill_of_lading_items[billOfLadingItemIndex].old_status = this.item.bill_of_lading_items[billOfLadingItemIndex].status;
        this.setBillOfLadingItemStatus(billOfLadingItemIndex, this.finishedGoodStatusIdToBeReturned);
      });

      this.$bus.$emit('loading-stop');
      this.tagQr = null;

      if (Object.keys(groupedErrors).length > 0) {
        this.$bus.$emit(
          'showError',
          buildErrorMessage(),
          null,
          'xl',
          5000
        );
      } else {
        this.$bus.$emit(
          'showSuccess',
          'Door and associated frames added successfully'
        );
      }
    },

    // addExtraItem(item) {
    //   if (!item) return;
    //   console.log('here: ', item);
    //   const index = this.item.bill_of_lading_extra_items.findIndex((x) => x.temp_id === item.temp_id);
    //   if (index >= 0) {
    //     this.item.bill_of_lading_extra_items.splice(index, 1, item);
    //   } else {
    //     this.item.bill_of_lading_extra_items.push(item);
    //   }
    // },

    // removeExtraItem(item) {
    //   if (!item) return;
    //   console.log('removeExtraItem: ', item);
    //   let index;
    //   if (item.temp_id) {
    //     index = this.item.bill_of_lading_extra_items.findIndex((x) => x.temp_id === item.temp_id);
    //   } else {
    //     index = this.item.bill_of_lading_extra_items.findIndex((x) => x.id === item.id);
    //   }
    //   this.item.bill_of_lading_extra_items.splice(index, 1);
    // },

    openExtraItemForm() {
      this.$refs.billOfLadingExtraItemForm.open();
    },

    isScanned(item) {
      const index = this.item.bill_of_lading_items.findIndex(
        (x) => x.finished_good.id === item.id,
      );
      return index >= 0;
    },

    isSameJob(item) {
      if (this.item.job_id !== null) {
        return this.item.job_id === item.commercial_schedule.job_id;
      }

      const firstItem = this.item.bill_of_lading_items[0];

      if (firstItem !== null && firstItem !== undefined) {
        const firstItemJobId = firstItem.finished_good.commercial_schedule.job_id;
        const addedItemJobId = item.commercial_schedule.job_id;

        return firstItemJobId === addedItemJobId;
      } else {
        return true;
      }
    },

    async isTagAssignedToPendingBillOfLading(item) {
      //check if tag is already under a bill of lading and is pending
      const readModel = {
        filters: {
          finished_good_commercial_id: item.id,
          status_id: this.billOfLadingStatusIdPending,
        },
      };

      const res = await this.$api.commercialBillOfLading.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].id;
      }

      return null;
    },

    isSameBillOfLading(billOfLadingId) {
      const firstItem = this.item.bill_of_lading_items[0];

      const firstItemBillOfLadingId = firstItem.commercial_bill_of_lading_id;

      return firstItemBillOfLadingId === billOfLadingId;
    },

    async isTagAssigned(item) {
      // check if tag is already under a bill of lading and is shipped or received (could be under a bill of lading, but returned - in which case we can still add it to another bill of lading)
      const readModel = {
        filters: {
          finished_good_commercial_id: item.id,
          status_id: [this.finishedGoodStatusIdShipped, this.finishedGoodStatusIdReceived],
        },
      };

      const res = await this.$api.commercialBillOfLadingItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_bill_of_lading_id;
      }

      return null;
    },

    isBundleScanned(bundle) {
      return this.item.bill_of_lading_items.some(
        (x) => x.commercial_bundle?.id === bundle.id
      );
    },

    isBundleSameJob(bundle) {
      if (!bundle) return false;

      if (this.item.job_id !== null) {
        return this.item.job_id === bundle.job_id;
      }

      const firstItem = this.item.bill_of_lading_items[0];

      if (!firstItem) {
        return true;
      }

      let firstItemJobId = null;

      if (firstItem.finished_good) {
        firstItemJobId = firstItem.finished_good?.commercial_schedule?.job_id ?? null;
      } else if (firstItem.commercial_bundle) {
        firstItemJobId = firstItem.commercial_bundle?.job_id ?? null;
      } else if (firstItem.commercial_skid) {
        firstItemJobId = firstItem.commercial_skid?.job_id ?? null;
      }

      return firstItemJobId === bundle.job_id;
    },

    async isBundleAssignedToBillOfLading(bundle) {
      //currently doesn't check if the bundle has been returned - could be under a bill of lading but returned - in which case we can still add it to another bill of lading
      const readModel = {
        filters: {
          commercial_bundle_id: bundle.id,
        },
      };

      const res = await this.$api.commercialBillOfLadingItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_bill_of_lading_id;
      }

      return null;
    },

    async isBundleAssignedToSkid(bundle) {
      // check if bundle is already under a skid
      const readModel = {
        filters: {
          commercial_bundle_id: bundle.id,
        },
      };

      const res = await this.$api.commercialSkidItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_skid.skid_number;
      }

      return null;
    },

    isSkidScanned(skid) {
      return this.item.bill_of_lading_items.some(
        (x) => x.commercial_skid?.id === skid.id
      );
    },

    isSkidSameJob(skid) {
      if (!skid) return false;

      if (this.item.job_id !== null) {
        return this.item.job_id === skid.job_id;
      }

      const firstItem = this.item.bill_of_lading_items[0];

      if (!firstItem) {
        return true;
      }

      let firstItemJobId = null;

      if (firstItem.finished_good) {
        firstItemJobId = firstItem.finished_good?.commercial_schedule?.job_id ?? null;
      } else if (firstItem.commercial_bundle) {
        firstItemJobId = firstItem.commercial_bundle?.job_id ?? null;
      } else if (firstItem.commercial_skid) {
        firstItemJobId = firstItem.commercial_skid?.job_id ?? null;
      }

      return firstItemJobId === skid.job_id;
    },

    async isSkidAssignedToBillOfLading(skid) {
      //currently doesn't check if the skid has been returned - could be under a bill of lading but returned - in which case we can still add it to another bill of lading
      const readModel = {
        filters: {
          commercial_skid_id: skid.id,
        },
      };

      const res = await this.$api.commercialBillOfLadingItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_bill_of_lading_id;
      }

      return null;
    },

    isReturned(item) {
      return item.status_id === this.finishedGoodStatusIdReturned;
    },

    // async removeTag(item) {
    //   const confirm = await this.$refs.confirmForm.open({
    //     title: 'Are you sure that you want to remove this record?',
    //   });
    //   if (!confirm) return;
    //   if (item.is_return) {
    //     const itemIndex = this.item.bill_of_lading_items.findIndex((x) => x.finished_good.id === item.finished_good_commercial_id);
    //     if (itemIndex >= 0) {
    //       this.item.bill_of_lading_items[itemIndex].is_return = 0;
    //     }
    //   } else {
    //     const itemIndex = this.item.bill_of_lading_items.findIndex((x) => x.finished_good.id === item.finished_good.id);
    //     if (itemIndex >= 0) {
    //       this.item.bill_of_lading_items.splice(itemIndex, 1);
    //     }
    //   }
    // },

    async removeTag(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to remove this record?',
      });
      if (!confirm) return;

      if (item.is_return) {
        const itemIndex = this.item.bill_of_lading_items.findIndex(
          (x) =>
            x.finished_good &&
            item.finished_good_commercial_id &&
            x.finished_good.id === item.finished_good_commercial_id
        );

        if (itemIndex >= 0) {
          this.item.bill_of_lading_items[itemIndex].is_return = 0;
        }

        return;
      }

      let itemIndex = -1;

      if (item.finished_good) {
        itemIndex = this.item.bill_of_lading_items.findIndex(
          (x) => x.finished_good && x.finished_good.id === item.finished_good.id
        );
      } else if (item.commercial_bundle) {
        itemIndex = this.item.bill_of_lading_items.findIndex(
          (x) =>
            x.commercial_bundle &&
            x.commercial_bundle.id === item.commercial_bundle.id
        );
      } else if (item.commercial_skid) {
        itemIndex = this.item.bill_of_lading_items.findIndex(
          (x) =>
            x.commercial_skid &&
            x.commercial_skid.id === item.commercial_skid.id
        );
      }

      if (itemIndex >= 0) {
        this.item.bill_of_lading_items.splice(itemIndex, 1);
      }
    },

    async toggleReturnTag(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure you want to ${item.is_return ? 'undo return?' : 'return this record?'}`,
      });
      if (!confirm) return;
      const billOfLadingItemIndex = this.item.bill_of_lading_items.findIndex((x) => x.finished_good.id === item.finished_good_id);
      if (billOfLadingItemIndex < 0) {
        this.$bus.$emit('showError', 'Unable to find item');
        return;
      }
      if (item.is_return) {
        // if a BOL exists with this item as shipped or received do not allow undo return
        const readModel = {
          filters: {
            finished_good_commercial_id: this.item.bill_of_lading_items[billOfLadingItemIndex].finished_good_commercial_id,
            status_id: [this.finishedGoodStatusIdShipped, this.finishedGoodStatusIdReceived],
          },
        };
        const res = await this.$api.commercialBillOfLadingItem.read(readModel);
        if (!res || !res.data) {
          this.$bus.$emit('showError', 'Unable to determine if this finished good exists in another Bill Of Lading as Shipped or Received');
          return;
        }
        if (res.data.length > 0) {
          const billOfLadingItems = res.data;
          const shippedOrReceivedBillOfLadingItemExists = billOfLadingItems.some((billOfLadingItem) => billOfLadingItem.id !== item.id);
          if (shippedOrReceivedBillOfLadingItemExists) {
            const billOfLadingItemStatus = res.data[0].status.name;
            const billOfLadingCode = res.data[0].bill_of_lading.code;
            this.$bus.$emit('showError', `This finished good is ${billOfLadingItemStatus} in Bill Of Lading #${billOfLadingCode}`);
            return;
          }
        }
      }
      if (item.status_id === this.finishedGoodStatusIdReturned) {
        if (!this.item.bill_of_lading_items[billOfLadingItemIndex].old_status) {
          this.item.bill_of_lading_items[billOfLadingItemIndex].old_status = this.item.bill_of_lading_items[billOfLadingItemIndex].status;
        }
        if (this.item.status_id === this.billOfLadingStatusIdReceived) {
          this.setBillOfLadingItemStatus(billOfLadingItemIndex, this.finishedGoodStatusIdReceived);
        } else if (this.item.status_id === this.billOfLadingStatusIdShipped) {
          this.setBillOfLadingItemStatus(billOfLadingItemIndex, this.finishedGoodStatusIdShipped);
        }
        this.$set(this.item.bill_of_lading_items[billOfLadingItemIndex], 'is_return', 0);
      } else if (item.old_status && item.old_status.id === this.finishedGoodStatusIdReturned) {
        this.item.bill_of_lading_items[billOfLadingItemIndex].status = this.item.bill_of_lading_items[billOfLadingItemIndex].old_status;
        this.item.bill_of_lading_items[billOfLadingItemIndex].status_id = this.item.bill_of_lading_items[billOfLadingItemIndex].old_status.id;
        delete this.item.bill_of_lading_items[billOfLadingItemIndex].is_return;
      } else if (item.is_return) {
        this.item.bill_of_lading_items[billOfLadingItemIndex].status = this.item.bill_of_lading_items[billOfLadingItemIndex].old_status;
        this.item.bill_of_lading_items[billOfLadingItemIndex].status_id = this.item.bill_of_lading_items[billOfLadingItemIndex].old_status.id;
        this.$set(this.item.bill_of_lading_items[billOfLadingItemIndex], 'is_return', 0);
      } else {
        // if no old status, then set old status to status from db else do nothing
        if (!this.item.bill_of_lading_items[billOfLadingItemIndex].old_status) {
          this.item.bill_of_lading_items[billOfLadingItemIndex].old_status = this.item.bill_of_lading_items[billOfLadingItemIndex].status;
        }
        this.$set(this.item.bill_of_lading_items[billOfLadingItemIndex], 'is_return', 1);
        this.setBillOfLadingItemStatus(billOfLadingItemIndex, this.finishedGoodStatusIdToBeReturned);
      }
    },

    setBillOfLadingItemStatus(index, statusId) {
      const item = this.item.bill_of_lading_items[index];
      let status = null;

      switch (statusId) {
        case this.finishedGoodStatusIdToBeReturned:
          status = this.finishedGoodStatusToBeReturned;
          break;
        case this.finishedGoodStatusIdReceived:
          status = this.finishedGoodStatusReceived;
          break;
        case this.finishedGoodStatusIdShipped:
          status = this.finishedGoodStatusShipped;
          break;
        default:
          return;
      }

      item.status_id = statusId;
      item.status = { ...status };
    },

    extractSequenceNumber(finishedGood) {
      const tagId = finishedGood?.tag_id;
      if (!tagId) return '-';

      const parts = tagId.split('-');
      return parts.length > 1 ? parts[parts.length - 1] : '-';
    },

    extractIdFromQrCode(qrCode) {
      if (!qrCode) return false;

      const match = qrCode.match(/^cl0*([1-9]\d*)/i);
      return match ? match[1] : false;
    },

    qrCodeValueChange() {
      if (!this.tagQr) return;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.handleTagAction();
      }, 700);
    },

    hasDoor(finishedGoods) {
      return finishedGoods.some((fg) => fg.type_id === this.finishedGoodCommercialTypeIdDoor);
    },

    headlineText() {
      if (this.item.id) {
        return 'Update';
      }
      return 'Create';
    },

    submitBtnText() {
      if (this.billOfLadingQr && this.isReceivedState) {
        return 'Undo Receive';
      }
      if (this.billOfLadingQr && this.isShippedState) {
        return 'Receive';
      }
      if (this.returnItem) {
        return 'Submit';
      }
      if (this.item.id) {
        return 'Update';
      }
      return 'Submit';
    },

    isSubmitBtn() {
      if (this.isOpen || this.isReturnedState) {
        return false;
      }
      return true;
    },

    // getWeightKilograms(item) {
    //   if (item.finished_good.type_id === this.finishedGoodCommercialTypeIdFrame || item.finished_good.type_id === this.finishedGoodCommercialTypeIdSlab) {
    //     // For frames, weight is calculated differently
    //     const length = this.getLengthFromFinishedGoodComponent(item.finished_good);
    //     if (!length) return 0;
    //     return length * item.finished_good.type.weight_ratio;
    //   }
    //   return item.finished_good.sqft * item.finished_good.type.weight_ratio;
    // },

    getFinishedGoodWeightKilograms(finishedGood) {
      if (!finishedGood || !finishedGood.type) return null;

      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame || finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab) {
        const length = this.getLengthFromFinishedGoodComponent(finishedGood);
        if (!length) return null;
        if (!finishedGood.aluminum_die || !finishedGood.aluminum_die.weight_ratio) return null;
        return length * finishedGood.aluminum_die.weight_ratio;
      }

      if (!finishedGood.sqft || !finishedGood.type.weight_ratio) return null;

      return finishedGood.sqft * finishedGood.type.weight_ratio;
    },

    getTotalSqft() {
      return this.item.bill_of_lading_items.reduce((acc, item) => acc + parseFloat(item.finished_good.sqft ? item.finished_good.sqft : 0), 0);
    },

    getTotalWidth() {
      return this.item.bill_of_lading_items.reduce((acc, item) => acc + parseFloat(item.finished_good.width && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdSlab ? item.finished_good.width : 0), 0);
    },

    getTotalHeight() {
      return this.item.bill_of_lading_items.reduce((acc, item) => acc + parseFloat(item.finished_good.height && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdFrame && item.finished_good.type_id !== this.finishedGoodCommercialTypeIdSlab ? item.finished_good.height : 0), 0);
    },

    getTotalLength(){
      let totalLength = this.item.bill_of_lading_items.reduce((acc, item) => {
        let accLength = acc;
        let itemLength = 0
        if (item.finished_good.type_id == this.finishedGoodCommercialTypeIdFrame || item.finished_good.type_id === this.finishedGoodCommercialTypeIdSlab) {
          itemLength = this.getLengthFromFinishedGoodComponent(item.finished_good);
        }
        // acc + parseFloat(item.finished_good.height && item.finished_good.type_id == this.finishedGoodCommercialTypeIdFrame ? item.finished_good.height : 0)
        return accLength + itemLength;
      }, 0);
      return totalLength;
    },

    // getTotalQuantity() {
    //   if (this.item && this.item.job && this.item.job.sub_class_id === this.jobSubClassIdCommDoors && this.businessRulesGetBoolean('Streamline Door Scanning')) {
    //     //if door job and streamline door scanning enabled then we only count the bill of lading items that are type door
    //     console.log('here');
    //     return this.item.bill_of_lading_items.reduce((acc, item) => {
    //       if (item.finished_good.type_id === this.finishedGoodCommercialTypeIdDoor) {
    //         return acc + 1;
    //       }
    //       return acc;
    //     }, 0);
    //   }
    //   console.log('here2');
    //   return this.item.bill_of_lading_items.length;
    // },

    getTotalQuantity() {
      const extraItemCount = this.item && this.item.bill_of_lading_extra_items
        ? this.item.bill_of_lading_extra_items.length
        : 0;

      if (this.isWindowMode() || !this.bolMode) {
        return this.getTotalFinishedGoodCount() + extraItemCount;
      }

      if (this.item && this.item.job && this.item.job.sub_class_id === this.jobSubClassIdCommDoors && this.businessRulesGetBoolean('Streamline Door Scanning')) {
        //if door job and streamline door scanning enabled then we only count the bill of lading items that are type door
        return this.item.bill_of_lading_items.reduce((acc, item) => {
          if (
            item.finished_good &&
            item.finished_good.type_id === this.finishedGoodCommercialTypeIdDoor
          ) {
            return acc + 1;
          }
          return acc;
        }, 0) + extraItemCount;
      }

      return this.item.bill_of_lading_items.length + extraItemCount;
    },

    // getTotalWeightKilograms() {
    //   //if door job then then we only sum the bill of lading items that are type door
    //   if (this.item && this.item.job && this.item.job.sub_class_id === this.jobSubClassIdCommDoors) {
    //     return this.item.bill_of_lading_items.reduce((acc, item) => {
    //       if (item.finished_good.type_id === this.finishedGoodCommercialTypeIdDoor) {
    //         return acc + this.getWeightKilograms(item);
    //       }
    //       return acc;
    //     }, 0);
    //   }
    //   return this.item.bill_of_lading_items.reduce((acc, item) => acc + this.getWeightKilograms(item), 0);
    // },

    getTotalWeightKilograms() {
      //if door job and streamline door scanning enabled then we only sum the bill of lading items that are type door
      if (this.item && this.item.job && this.item.job.sub_class_id === this.jobSubClassIdCommDoors && this.businessRulesGetBoolean('Streamline Door Scanning')) {
        return this.item.bill_of_lading_items.reduce((acc, item) => {
          if (item.finished_good && item.finished_good.type_id === this.finishedGoodCommercialTypeIdDoor) {
            return acc + this.getRowWeightKilograms(item);
          }
          return acc;
        }, 0);
      }

      return this.item.bill_of_lading_items.reduce(
        (acc, item) => acc + this.getRowWeightKilograms(item),
        0
      );
    },

    getAllTotalWeightKilograms() {
      let total = this.getTotalWeightKilograms();
      const extraItemsTotalWeight = this.$refs.billOfLadingExtraItemForm ? this.$refs.billOfLadingExtraItemForm.getTotalWeightKilograms() : 0;
      total += extraItemsTotalWeight;
      return total;
    },

    getAllTotalWeightPounds() {
      return this.getAllTotalWeightKilograms() * 2.20462;
    },

    getTotalWeightColor() {
      let truckWeight = 0;

      if (this.item.truck_schedule_truck_id) {
        const truck = this.trucks.find((truck) => truck.id === this.item.truck_schedule_truck_id);
        if (!truck) return 'red';
        truckWeight = truck.type.weight_limit;
      } else if (this.truckTypeId) {
        const truckType = this.truckTypes.find((truckType) => truckType.id === this.truckTypeId);
        if (!truckType) return 'red';
        truckWeight = parseFloat(truckType.weight_limit);
      } else {
        return '#000';
      }

      return truckWeight > this.getAllTotalWeightKilograms() ? '#000' : 'red';
    },

    isTruckOverweight() {
      let truckWeight = 0;

      if (this.item.truck_schedule_truck_id) {
        const truck = this.trucks.find((truck) => truck.id === this.item.truck_schedule_truck_id);
        if (!truck) return 'red';
        truckWeight = truck.type.weight_limit;
      }

      if (this.getAllTotalWeightKilograms() > truckWeight) {
        return true;
      }
      return false;
    },

    convertMillimetersToInches(millimeters) {
      return millimeters / 25.4;
    },

    displayInchesWithFraction(inches) {
      // Convert height to the raw number with rounding
      const raw = Math.round(inches / 0.0625) * 0.0625;

      // Extract the whole number part
      const wholeNumber = Math.floor(raw);

      // Calculate the decimal part
      const decInput = parseFloat((raw - wholeNumber).toFixed(4));

      // Initialize numerator and denominator
      let numerator = 1;
      let denominator = 1;

      // Calculate the fraction
      let decimalFraction = numerator / denominator;
      while (decimalFraction !== decInput) {
        if (decimalFraction < decInput) {
          numerator += 1;
        } else {
          denominator += 1;
          numerator = Math.floor(decInput * denominator);
        }
        decimalFraction = numerator / denominator;
      }

      // Create the final output string
      let result = '';
      if (wholeNumber > 0) {
        result += `${wholeNumber}"`;
      }

      if (numerator > 0) {
        result += `-${numerator}/${denominator}''`;
      }

      return result;
    },

    itemRowBackground(item) {
      return item.is_return || (item.status_id === this.finishedGoodStatusIdReturned) ? 'red-background' : '';
    },

    headlineText() {
      if (this.returnItem) {
        return this.item.id ? `Return Items: Commercial Bill Of Lading #${this.item.id}` : 'Return Items';
      }
      return this.item.id ? `Commercial Bill Of Lading #${this.item.id}` : 'Create Commercial Bill Of Lading';
    },

    formatDateTime(dateTime) {
      return FormatHelpers.convertDateTimeFormat(dateTime);
    },

    onResize() {
      this.tableHeight = Math.floor((window.innerHeight * (0.75))) - this.topSpaceHeight;
    },

    async getAddressData(addressData, placeData) {
      // console.log('addressData: ', addressData);
      // console.log('placeData: ', placeData);
      this.item.ship_to_address = placeData.formatted_address;
      // this.submitData.address.addressLine1 = `${addressData.street_number ? `${addressData.street_number} ` : ''}${addressData.route}`
      // if (addressData.postal_code) {
      //   this.submitData.address.postalCode = addressData.postal_code
      // } else if (placeData && placeData.address_components && placeData.address_components.some(x => x.types && x.types.some(y => y === 'postal_code' || y === 'postal_code_prefix'))) {
      //   this.submitData.address.postalCode = placeData.address_components.find(x => x.types.some(y => y === 'postal_code' || y === 'postal_code_prefix')).long_name
      // }
      // this.submitData.address.cityName = addressData.locality
      // this.submitData.address.province = addressData.administrative_area_level_1 // gives 2 character province code
      // this.submitData.address.googlePlaceId = addressData.place_id
      // this.submitData.address.latitude = addressData.latitude
      // this.submitData.address.longitude = addressData.longitude
      // this.submitData.address.country = addressData.country
    },


    isUndoStatusButtonVisible() {
      const hasReturnedItem = this.item?.bill_of_lading_items?.some(x => x.status_id === this.finishedGoodStatusIdReturned);

      if (hasReturnedItem) return false;

      return this.isAdmin && this.item?.status_id === this.billOfLadingStatusIdReceived;
    },

    undoStatusButtonText() {
      switch (this.item.status_id) {
        // case this.billOfLadingStatusIdShipped:
        //   return 'UNDO SHIP';
        case this.billOfLadingStatusIdReceived:
          return 'UNDO RECEIVE';
        default:
          return '';
      }
    },

    async undoStatus() {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure you want to ${this.undoStatusButtonText(this.item)} Bill Of Lading #${this.item.id}?`,
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const statusId = this.getUndoStatusId(this.item);
      const updateModel = {
        status_id: statusId,
        id: this.item.id,
      };
      const res = await this.$api.commercialBillOfLading.update(updateModel, `undo-status`);
      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      return true;
    },

    isSetStatusButtonVisible() {
      if (!this.item || !this.item.status_id) return false;
      if (this.item.status_id === this.billOfLadingStatusIdShipped) {
        return this.isAdmin;
      }
      return this.item.status_id === this.billOfLadingStatusIdPending;
    },

    setStatusButtonText() {
      switch (this.item.status_id) {
        case this.billOfLadingStatusIdPending:
          return 'SHIP';
        case this.billOfLadingStatusIdShipped:
          return 'RECEIVE';
        default:
          return '';
      }
    },

    async setStatus() {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure you want to ${this.setStatusButtonText(this.item)} Bill Of Lading #${this.item.id}?`,
      });
      if (!confirm) return false;
      this.$bus.$emit('loading');
      const statusId = this.getStatusId(this.item);
      if (!this.item.ship_to_address) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Please set the shipping address before proceeding.');
        return false;
      }
      const updateModel = {
        status_id: statusId,
        id: this.item.id,
      };
      const res = await this.$api.commercialBillOfLading.update(updateModel, `status`);
      this.$bus.$emit('loading-stop');
      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('showSuccess');
      return true;
    },

    getStatusId(item) {
      if (item.status_id === this.billOfLadingStatusIdPending) {
        return this.billOfLadingStatusIdShipped;
      }
      if (item.status_id === this.billOfLadingStatusIdShipped) {
        return this.billOfLadingStatusIdReceived;
      }
      return null;
    },

    getUndoStatusId(item) {
      if (item.status_id === this.billOfLadingStatusIdReceived) {
        return this.billOfLadingStatusIdShipped;
      }
      if (item.status_id === this.billOfLadingStatusIdShipped) {
        return this.billOfLadingStatusIdPending;
      }
      return null;
    },

    openInstallerInformationForm() {
      //
    },

    openNoteForm() {
      this.$refs.noteForm.open(
        this.item.id,
        this.noteTypeIdBillOfLading
      );
    },

    isNewNote(note) {
      if (!this.item.latest_note) return true;
      return this.item.latest_note.text !== note;
    },

    getLengthFromFinishedGoodComponent(finishedGood) {
      if (
        !finishedGood ||
        (finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab)
      ) {
        return 0;
      }
      if (finishedGood.width != null) {
        return finishedGood.width;
      }
      if (finishedGood.height != null) {
        return finishedGood.height;
      }
    },

    // toggleExpand(item) {
    //   if (!item) return;
    //   const index = this.expandedItems.indexOf(item);
    //   if (index > -1) {
    //     this.expandedItems.splice(index, 1);
    //   } else {
    //     this.expandedItems.push(item);
    //   }
    // },

    toggleExpand(item) {
      if (!item) return;

      const expandedItems = this.isDoorMode()
        ? this.expandedDoorItems
        : this.expandedWindowItems;

      const index = expandedItems.indexOf(item);

      if (index > -1) {
        expandedItems.splice(index, 1);
      } else {
        expandedItems.push(item);
      }

      // this.syncExpandAllPanelsState();
    },

    isWindowRowExpandable(item) {
      if (!item) return false;

      return !!(
        item.is_finished_good_group ||
        item.finished_good ||
        item.commercial_bundle ||
        item.commercial_skid
      );
    },

    getWindowRowType(item) {
      if (item.is_finished_good_group) return 'Finished Good';
      if (item.finished_good) return 'Finished Good';
      if (item.commercial_bundle) return 'Bundle';
      if (item.commercial_skid) return 'Skid';
      return 'Unknown Type';
    },

    getWindowRowNumberOrTag(item) {
      if (item.is_finished_good_group) return item.tag_number || 'Unknown Tag';
      if (item.finished_good) return item.finished_good.tag_id || 'Unknown Tag';
      if (item.commercial_bundle) return item.commercial_bundle.bundle_number || 'Unknown Bundle Number';
      if (item.commercial_skid) return item.commercial_skid.skid_number || 'Unknown Skid Number';
      return 'Unknown Number/Tag';
    },

    getWindowRowQuantity(item) {
      if (item.is_finished_good_group) return item.finished_goods.length;
      if (item.finished_good) return 1;

      if (item.commercial_bundle) {
        return item.commercial_bundle.commercial_bundle_items
          ? item.commercial_bundle.commercial_bundle_items.length
          : 0;
      }

      if (item.commercial_skid) {
        return item.commercial_skid.commercial_skid_items
          ? item.commercial_skid.commercial_skid_items.length
          : 0;
      }

      return 0;
    },

    getWindowRowWorkOrder(item) {
      if (item.finished_good) {
        return item.finished_good.work_order || 'Unknown Work Order';
      }

      if (item.commercial_bundle) {
        return item.commercial_bundle?.job?.code || 'Unknown Work Order';
      }

      if (item.commercial_skid) {
        return item.commercial_skid?.job?.code || 'Unknown Work Order';
      }

      return 'Unknown Work Order';
    },

    getWindowRowReference(item) {
      if (item.finished_good) {
        return item.finished_good.floor_number || 'Unknown Reference';
      }

      if (item.commercial_bundle) {
        return item.commercial_bundle?.job?.reference || 'Unknown Reference';
      }

      if (item.commercial_skid) {
        return item.commercial_skid?.job?.reference || 'Unknown Reference';
      }

      return 'Unknown Reference';
    },

    getWindowRowChildren(item) {
      // direct FG → expanded content gets a one-item array with that FG
      // bundle → expanded content gets the bundle’s finished goods
      // skid → expanded content gets the skid’s top-level skid items
      if (item.is_finished_good_group) {
        return item.finished_goods || [];
      }

      if (item.finished_good) {
        return item.finished_good ? [item.finished_good] : [];
      }

      if (item.commercial_bundle) {
        const bundleItems = item.commercial_bundle.commercial_bundle_items || [];
        const finishedGoods = [];

        bundleItems.forEach((bundleItem) => {
          if (bundleItem.finished_good) {
            finishedGoods.push(bundleItem.finished_good);
          }
        });

        return finishedGoods;
      }

      if (item.commercial_skid) {
        return item.commercial_skid.commercial_skid_items || [];
      }

      return [];
    },

    getWindowSkidChildRowType(item) {
      if (item.finished_good) return 'Finished Good';
      if (item.commercial_bundle) return 'Bundle';
      return 'Unknown Type';
    },

    getWindowSkidChildRowNumberOrTag(item) {
      if (item.finished_good) {
        return item.finished_good.tag_id || 'Unknown Tag';
      }

      if (item.commercial_bundle) {
        return item.commercial_bundle.bundle_number || 'Unknown Bundle Number';
      }

      return 'Unknown Number/Tag';
    },

    getWindowSkidChildRowQuantity(item) {
      if (item.finished_good) return 1;

      if (item.commercial_bundle) {
        return item.commercial_bundle.commercial_bundle_items
          ? item.commercial_bundle.commercial_bundle_items.length
          : 0;
      }

      return 0;
    },

    getWindowSkidChildRowWorkOrder(item) {
      if (item.finished_good) {
        return item.finished_good.work_order || 'Unknown Work Order';
      }

      if (item.commercial_bundle) {
        return item.commercial_bundle?.job?.code || 'Unknown Work Order';
      }

      return 'Unknown Work Order';
    },

    getWindowSkidChildRowReference(item) {
      if (item.finished_good) {
        return item.finished_good.floor_number || 'Unknown Reference';
      }

      if (item.commercial_bundle) {
        return item.commercial_bundle?.job?.reference || 'Unknown Reference';
      }

      return 'Unknown Reference';
    },

    isWindowSkidChildRowExpandable(item) {
      if (!item) return false;

      return !!(
        item.finished_good ||
        item.commercial_bundle
      );
    },

    getWindowSkidChildRowChildren(item) {
      if (item.finished_good) {
        return item.finished_good ? [item.finished_good] : [];
      }

      if (item.commercial_bundle) {
        const bundleItems = item.commercial_bundle.commercial_bundle_items || [];
        const finishedGoods = [];

        bundleItems.forEach((bundleItem) => {
          if (bundleItem.finished_good) {
            finishedGoods.push(bundleItem.finished_good);
          }
        });

        return finishedGoods;
      }

      return [];
    },

    toggleSkidChildExpand(item) {
      if (!item) return;

      const index = this.expandedSkidChildItems.indexOf(item);

      if (index > -1) {
        this.expandedSkidChildItems.splice(index, 1);
      } else {
        this.expandedSkidChildItems.push(item);
      }

      // this.syncExpandAllPanelsState();
    },

    getFinishedGoodTagId(finishedGood) {
      return finishedGood && finishedGood.tag_id ? finishedGood.tag_id : '-';
    },

    getFinishedGoodTagNumber(finishedGood) {
      return finishedGood && finishedGood.tag_number ? finishedGood.tag_number : '-';
    },

    getFinishedGoodSequenceNumber(finishedGood) {
      return this.extractSequenceNumber(finishedGood);
    },

    getFinishedGoodType(finishedGood) {
      return finishedGood && finishedGood.type ? finishedGood.type.name : '-';
    },

    getFinishedGoodAluminumDieCode(finishedGood) {
      return finishedGood && finishedGood.aluminum_die && finishedGood.aluminum_die.code ? finishedGood.aluminum_die.code : '-';
    },

    getFinishedGoodIntColorCode(finishedGood) {
      return finishedGood && finishedGood.int_color && finishedGood.int_color.code ? finishedGood.int_color.code : '-';
    },

    getFinishedGoodExtColorCode(finishedGood) {
      return finishedGood && finishedGood.ext_color && finishedGood.ext_color.code ? finishedGood.ext_color.code : '-';
    },

    hasFinishedGoodStatus(finishedGood) {
      return finishedGood && finishedGood.status ? true : false;
    },

    getFinishedGoodStatusColor(finishedGood) {
      return finishedGood && finishedGood.status ? finishedGood.status.color : '#000000';
    },

    getFinishedGoodStatusName(finishedGood) {
      return finishedGood && finishedGood.status ? finishedGood.status.name : '';
    },

    getFinishedGoodSqft(finishedGood) {
      return finishedGood && finishedGood.sqft ? `${finishedGood.sqft.toFixed(2)} sqft` : '-';
    },

    getFinishedGoodWidth(finishedGood) {
      return finishedGood
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab
        && finishedGood.width
        ? this.displayInchesWithFraction(finishedGood.width)
        : '-';
    },

    getFinishedGoodHeight(finishedGood) {
      return finishedGood
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame
        && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab
        && finishedGood.height
        ? this.displayInchesWithFraction(finishedGood.height)
        : '-';
    },

    getFinishedGoodLength(finishedGood) {
      if (!finishedGood) return '-';

      const isValidType =
        finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame ||
        finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab;

      if (!isValidType) return '-';

      const length = this.getLengthFromFinishedGoodComponent(finishedGood);

      return length ? this.displayInchesWithFraction(length) : '-';
    },

    getFinishedGoodWeight(finishedGood) {
      if (!finishedGood) return 'Unable to calculate weight';
      if (!finishedGood.type) return 'Unable to calculate weight';

      const weight = this.getFinishedGoodWeightKilograms(finishedGood);

      return weight
        ? parseFloat(weight).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
        : 'Unable to calculate weight';
    },

    getBundleFinishedGoods(bundle) {
      if (!bundle || !bundle.commercial_bundle_items) return [];

      const finishedGoods = [];

      bundle.commercial_bundle_items.forEach((bundleItem) => {
        if (bundleItem.finished_good) {
          finishedGoods.push(bundleItem.finished_good);
        }
      });

      return finishedGoods;
    },

    getSkidFinishedGoods(skid) {
      if (!skid || !skid.commercial_skid_items) return [];

      const finishedGoods = [];

      skid.commercial_skid_items.forEach((skidItem) => {
        if (skidItem.finished_good) {
          finishedGoods.push(skidItem.finished_good);
        } else if (skidItem.commercial_bundle) {
          finishedGoods.push(...this.getBundleFinishedGoods(skidItem.commercial_bundle));
        }
      });

      return finishedGoods;
    },

    getRowWeightKilograms(item) {
      if (!item) return 0;

      if (item.is_finished_good_group) {
        return item.finished_goods.reduce(
          (acc, finishedGood) => acc + this.getFinishedGoodWeightKilograms(finishedGood),
          0
        );
      }

      if (item.finished_good) {
        return ( this.getFinishedGoodWeightKilograms(item.finished_good) || 0);
      }

      if (item.commercial_bundle) {
        return this.getBundleFinishedGoods(item.commercial_bundle).reduce(
          (acc, finishedGood) => acc + (this.getFinishedGoodWeightKilograms(finishedGood) || 0),
          0
        );
      }

      if (item.commercial_skid) {
        return this.getSkidFinishedGoods(item.commercial_skid).reduce(
          (acc, finishedGood) => acc + (this.getFinishedGoodWeightKilograms(finishedGood) || 0),
          0
        );
      }

      return 0;
    },

    getTopLevelRowClass(commercialWindowItem) {
      if (commercialWindowItem.commercial_skid_id > 0 || commercialWindowItem.commercial_skid) {
        return 'commercial-bol-row-skid';
      }

      if (commercialWindowItem.commercial_bundle_id > 0 || commercialWindowItem.commercial_bundle) {
        return 'commercial-bol-row-bundle';
      }

      if (
        commercialWindowItem.is_finished_good_group ||
        commercialWindowItem.finished_good_id > 0 ||
        commercialWindowItem.finished_good
      ) {
        return 'commercial-bol-row-finished-good';
      }

      return '';
    },

    getWindowSkidChildRowClass(commercialSkidChildItem) {
      if (commercialSkidChildItem.commercial_bundle_id > 0 || commercialSkidChildItem.commercial_bundle) {
        return 'commercial-bol-row-bundle';
      }

      if (commercialSkidChildItem.finished_good_id > 0 || commercialSkidChildItem.finished_good) {
        return 'commercial-bol-row-finished-good';
      }

      return '';
    },

    getWindowRowWeight(item) {
      const weight = this.getRowWeightKilograms(item);

      return parseFloat(weight).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    getFinishedGoodRowClass() {
      return 'commercial-bol-row-finished-good';
    },

    getSubTableHeaderClass(parentItem) {
      if (!parentItem) return '';

      if (parentItem.commercial_skid) {
        return 'commercial-bol-header-skid';
      }

      if (parentItem.commercial_bundle) {
        return 'commercial-bol-header-bundle';
      }

      if (parentItem.finished_good) {
        return 'commercial-bol-header-finished-good';
      }

      return '';
    },

    getSubTableClass(parentItem) {
      if (!parentItem) return '';

      if (parentItem.commercial_skid) {
        return 'commercial-bol-subtable-skid';
      }

      if (parentItem.commercial_bundle) {
        return 'commercial-bol-subtable-bundle';
      }

      if (parentItem.is_finished_good_group || parentItem.finished_good) {
        return 'commercial-bol-subtable-finished-good';
      }

      return '';
    },

    getTotalSkidCount() {
      if (!this.item || !this.item.bill_of_lading_items) return 0;

      return this.item.bill_of_lading_items.filter(
        (item) => item.commercial_skid_id > 0 || item.commercial_skid
      ).length;
    },

    getTotalBundleCount() {
      if (!this.item || !this.item.bill_of_lading_items) return 0;

      let total = 0;

      this.item.bill_of_lading_items.forEach((item) => {
        if (item.commercial_bundle_id > 0 || item.commercial_bundle) {
          total += 1;
        }

        if (item.commercial_skid && item.commercial_skid.commercial_skid_items) {
          item.commercial_skid.commercial_skid_items.forEach((skidItem) => {
            if (skidItem.commercial_bundle_id > 0 || skidItem.commercial_bundle) {
              total += 1;
            }
          });
        }
      });

      return total;
    },

    getTotalFinishedGoodCount() {
      if (!this.item || !this.item.bill_of_lading_items) return 0;

      let total = 0;

      this.item.bill_of_lading_items.forEach((item) => {
        if (item.finished_good_id > 0 || item.finished_good) {
          total += 1;
        }

        if (item.commercial_bundle && item.commercial_bundle.commercial_bundle_items) {
          item.commercial_bundle.commercial_bundle_items.forEach((bundleItem) => {
            if (bundleItem.finished_good) {
              total += 1;
            }
          });
        }

        if (item.commercial_skid && item.commercial_skid.commercial_skid_items) {
          item.commercial_skid.commercial_skid_items.forEach((skidItem) => {
            if (skidItem.finished_good_id > 0 || skidItem.finished_good) {
              total += 1;
            }

            if (skidItem.commercial_bundle && skidItem.commercial_bundle.commercial_bundle_items) {
              skidItem.commercial_bundle.commercial_bundle_items.forEach((bundleItem) => {
                if (bundleItem.finished_good) {
                  total += 1;
                }
              });
            }
          });
        }
      });

      return total;
    },

    // getTotalFinishedGoodFrameAndSlabCount() {
    //   if (!this.item || !this.item.bill_of_lading_items) return 0;

    //   let total = 0;

    //   const isFrameOrSlab = (finishedGood) =>
    //     finishedGood && (finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame || finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab);

    //   this.item.bill_of_lading_items.forEach((item) => {
    //     if (isFrameOrSlab(item.finished_good)) {
    //       total += 1;
    //     }

    //     if (item.commercial_bundle && item.commercial_bundle.commercial_bundle_items) {
    //       item.commercial_bundle.commercial_bundle_items.forEach((bundleItem) => {
    //         if (isFrameOrSlab(bundleItem.finished_good)) {
    //           total += 1;
    //         }
    //       });
    //     }

    //     if (item.commercial_skid && item.commercial_skid.commercial_skid_items) {
    //       item.commercial_skid.commercial_skid_items.forEach((skidItem) => {
    //         if (isFrameOrSlab(skidItem.finished_good)) {
    //           total += 1;
    //         }

    //         if (skidItem.commercial_bundle && skidItem.commercial_bundle.commercial_bundle_items) {
    //           skidItem.commercial_bundle.commercial_bundle_items.forEach((bundleItem) => {
    //             if (isFrameOrSlab(bundleItem.finished_good)) {
    //               total += 1;
    //             }
    //           });
    //         }
    //       });
    //     }
    //   });

    //   return total;
    // },

    handleExpandAllChange(value) {
      if (value) {
        this.expandAllRows();
      } else {
        this.collapseAllRows();
      }
    },

    expandAllRows() {
      if (this.isDoorMode()) {
        this.expandedDoorItems = [...this.doorTableItems];
        this.expandedSkidChildItems = [];
        return;
      }

      // default / window mode
      this.expandedWindowItems = [...this.windowTableItems];

      const allSkidChildItems = [];

      this.item.bill_of_lading_items.forEach((row) => {
        if (row.commercial_skid && row.commercial_skid.commercial_skid_items) {
          row.commercial_skid.commercial_skid_items.forEach((skidChild) => {
            if (this.isWindowSkidChildRowExpandable(skidChild)) {
              allSkidChildItems.push(skidChild);
            }
          });
        }
      });

      this.expandedSkidChildItems = allSkidChildItems;
    },

    collapseAllRows() {
      this.expandedDoorItems = [];
      this.expandedWindowItems = [];
      this.expandedSkidChildItems = [];
    },

    openFinishedGoodForm() {
      if (this.$refs.finishedGoodForm) {
        this.$refs.finishedGoodForm.open();
      }
    },

    shouldShowTopLevelRemoveButton(item) {
      if (!item) return false;

      if (item.is_finished_good_group) {
        return item.finished_goods.length <= 1;
      }

      return true;
    },

    //This method is intended to keep the "Expand All" checkbox state in sync with individual row expansionW
    // syncExpandAllPanelsState() {
    //   if (this.isDoorMode()) {
    //     const totalExpandable = this.doorTableItems.length;
    //     this.expandAllPanels =
    //       totalExpandable > 0 &&
    //       this.expandedDoorItems.length === totalExpandable;
    //     return;
    //   }

    //   const topLevelItems = this.item?.bill_of_lading_items || [];
    //   const totalTopLevel = topLevelItems.length;

    //   let totalExpandableSkidChildren = 0;
    //   topLevelItems.forEach((row) => {
    //     if (row.commercial_skid && row.commercial_skid.commercial_skid_items) {
    //       row.commercial_skid.commercial_skid_items.forEach((skidChild) => {
    //         if (this.isWindowSkidChildRowExpandable(skidChild)) {
    //           totalExpandableSkidChildren += 1;
    //         }
    //       });
    //     }
    //   });

    //   const topLevelExpanded = totalTopLevel > 0 && this.expandedWindowItems.length === totalTopLevel;
    //   const skidChildrenExpanded =
    //     totalExpandableSkidChildren === 0 ||
    //     this.expandedSkidChildItems.length === totalExpandableSkidChildren;

    //   this.expandAllPanels = topLevelExpanded && skidChildrenExpanded;
    // },

    getFinishedGoodMissingField(finishedGood) {
      if (!finishedGood) return null;

      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow || finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor) return 'sqft';

      if (
        (finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame ||
          finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab) 
      ) {
        console.log('finishedGood in getFinishedGoodMissingField: ', finishedGood);
        if (!this.getLengthFromFinishedGoodComponent(finishedGood)) return 'length';
        console.log('finishedGood aluminum die in getFinishedGoodMissingField: ', finishedGood.aluminum_die);
        console.log('finishedGood aluminum die weight ratio in getFinishedGoodMissingField: ', finishedGood.aluminum_die ? finishedGood.aluminum_die.weight_ratio : 'no aluminum die');
        if (!finishedGood.aluminum_die) return 'aluminum die';
        if (!finishedGood.aluminum_die.weight_ratio) return 'aluminum die weight ratio';
      }

      return 'field';
    },
  },
};
</script>
<style scoped>
::v-deep .red-background {
  background-color: #ffe3e3;
}
::v-deep .commercial-bol-subtable.commercial-bol-subtable-skid
  .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background-color: #e6a84f !important;
  color: #ffffff !important;
}

::v-deep .commercial-bol-subtable.commercial-bol-subtable-bundle
  .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background-color: #e6d85c !important;
  color: #000000 !important;
}

::v-deep .commercial-bol-subtable.commercial-bol-subtable-finished-good
  .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background-color: #5aa469 !important;
  color: #ffffff !important;
}
::v-deep .commercial-bol-row-skid {
  background-color: #fff4e5 !important;
}

::v-deep .commercial-bol-row-bundle {
  background-color: #fffdeb !important;
}

::v-deep .commercial-bol-row-finished-good {
  background-color: #edf7ed !important;
}

::v-deep .commercial-bol-summary-text {
  font-size: 18px;
  font-weight: 600;
  color: #555;
}

::v-deep .commercial-bol-header-skid th {
  background-color: #e6a84f !important; /* darker orange */
  color: white;
}

::v-deep .commercial-bol-header-bundle th {
  background-color: #e6d85c !important; /* darker yellow */
  color: black;
}

::v-deep .commercial-bol-header-finished-good th {
  background-color: #5aa469 !important; /* darker green */
  color: white;
}

::v-deep .commercial-bol-subtable.level-1 {
  margin-left: 24px;
}

::v-deep .commercial-bol-subtable.level-2 {
  margin-left: 48px;
}

::v-deep .commercial-bol-expand-animate {
  animation: commercialBolSlideFadeIn 0.2s ease;
  transform-origin: top left;
}

@keyframes commercialBolSlideFadeIn {
  0% {
    opacity: 0;
    transform: translateX(-10px) translateY(-4px);
  }
  100% {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
/* @keyframes commercialBolSlideFadeIn {
  0% {
    opacity: 0;
    transform: translateX(-6px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
} */
</style>
